<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <meta name="title" content="">
    <meta name="keywords" content="">
    <meta name="description" content="">
    <title>Act Now </title>
    <style type="text/css">
        .loadingGif {
            display: none;
            position: fixed;
            top: 0px;
            right: 0px;
            width: 100%;
            height: 100%;
            background-color: #828282ad;
            background-image: none;
            background-repeat: no-repeat;
            background-position: center;
            z-index: 10000000;
            opacity: 1;
            filter: alpha(opacity=40); /* For IE8 and earlier */
        }

            .loadingGif img {
                position: absolute;
                top: 50%;
                right: 0px;
                left: 0;
                margin: 0px auto;
            }
        /*.ui-helper-clearfix { display:none; }*/
        #ui-datepicker-div {
            display: none;
        }
    </style>
    <link rel="stylesheet" type="text/css" href="http://www.dev.actnow.org.uk/css/ul-pagination.css">
    <link rel="stylesheet" type="text/css" href="http://www.dev.actnow.org.uk/css/notifier.css">
    <link rel="stylesheet" href="http://www.dev.actnow.org.uk/css/slick.css" type="text/css">
    <!-- <link href="http://www.dev.actnow.org.uk/css/style.css" type="text/css" rel="stylesheet"> -->
    <link href="http://www.dev.actnow.org.uk/css/style.css" type="text/css" rel="stylesheet" media="screen">
    <!--[if lt IE 9]>
    <script src="http://www.dev.actnow.org.uk/dist/html5shiv.js"></script>
    <![endif]-->

    <link href="http://www.dev.actnow.org.uk/plugins/datepicker/datepicker3.css" rel="stylesheet">
    <link href="http://ajax.googleapis.com/ajax/libs/jqueryui/1.8.5/themes/base/jquery-ui.css" rel="stylesheet" type="text/css">
    <!-- <link rel="stylesheet" type="text/css" href="http://www.dev.actnow.org.uk/css/notifier.css"> -->

    <link href="http://www.dev.actnow.org.uk/css/front-custom.css" type="text/css" rel="stylesheet">
    <link rel="icon" href="http://www.dev.actnow.org.uk/../images/favicon.png" type="image/x-icon">
    <style>
        @font-face {
            font-family: "wticons";
            src: url("data:font/woff2;charset=utf-8;base64,d09GMgABAAAAABvsAAsAAAAAQWQAABuZAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHIkYBlYAjBAK2wjJJQE2AiQDgnALgToABCAFhAoHhmkb/zZVIbBxAJAwnRJRlKxNSPb/lwRtSqgsHtJ2L2jGrCDbKXsRiTT6VKRF0Id2GfkKHqN91UWaMTRaXFt/9RUqyF1PyS/vqG/cUEp4/pmr9wYGlpASniTDWCBWe76uFIBCVtlXIACueZ/i74sCqaZZ4ejR5in8gMM1TT8AhmibB0+Y0IoNIoIVIAISEjZKmcGibFwaxSrMrV2pm4vWZTtxlS7ahS6So7U2tnpiey/iRDxTyZ8yMRKatkbIHgGD80IecRCDOTWpOZScYaA04NCAWVCEjZ/kA+vuJ939HKcEaRsaMBv2l+pvO/17+nCxW/fY2xjjTEAQGpB4QsRNETa1Oa5TOll9KgiDzbfWr97eV0NMLpHFvBTS7Nx9/s7O7RffHczuL7boHSaWROwEc288kiWT1z3TIdEsUgqlWK3QiMBD3KuaMe0HPM8eYkjGnJZYWuqFYg3W6iXqlRZNIK0YV7faTd+Bm7kipJ+x2e+B07u2GpkyLETM5f3cERQw7JJDHaSLTcbz17/6hGU6s18FSd1K/v67r5M0/OglzorkWRwfw6R9ob/5KVbKJq5UIe3VHrpI79iVT7xfLFDFzVMlmEwWm8Ol0Xg8CZPOhbre840XsXEGX38RUwKhSFogw2fIShqWFzAVFJUYcnLGDLFUVEkyLMGkW+azOOKWaAjZZaUSYk2UGKFz6ip0d+IcA1t0SIibpliCACzfUlIScHgMrqhZHLLwt5KftbosvqiDm1fFrZswwlLjqAsTfVxChEseDpVwp9a9uBXc+VGx2Z2mLZL9jO7qsnhb1uo7EAo06CcWuLm6sgf9yAxr3xdG+ZqRhzongZr00V2Bs4UHGiKOwKW4SknAVYypWdPinlQYHYmTYvxP0z5N0jHLlUkxsOtRpqmeJ4aSipy05FqyMex2IWaFbma+hMXnUHVDLZMsh2YqsELnaLBKxEVLkits+VVtlizLIl2ksVIbTNp0bNWILM2VGa+vH8iON6L1KwvEjbtU9JavPGcmFUwMWY9U5NdTU2oi+8ZEarAkYivJyEMZI+ccGqGTDnuFU3vN0MiOGNTqCuzSVFGrQndP71h06IYVCkBmTTRbZ07Ak1mfXEv14Wpm4IBOmowZw/Nzx/n7C88pBuKEFbpH48Tj7m4SGOwEaBCHIjln7nvsiWsd2rGsnIqahj4l/H8ZJBiL1d8APwY3XvlAMwhBFYswN6N6iN7iL7qlP/8B/ejtdWvBADGggdNrmr/aoZZTaqBF4inN8Mf+0QMVmDVJo0srKmvoeN9nfij9///xdaqe8Os+9EUJa64pKmatW9Tm/rlkyIOWgbqMno62rpSiPkOTyVtTKKsrRApySkRLhT+Tpm1lNU+q0hTB3mGOSUgaMmLUuAmTpsyYNWfegiXLVqxas2HTlm279uw7cOTYqTPnLly6cu3GrTv3HjxBSTFNtDb1TK8DMEQJpBbwWgzpGGu+J21k8/DPPy05VgX4A9cuq56qCqDOUYD2gKo14DtTtECKAQiog5AMiOiBNB1QpA3K7S5vAUiBRrvIXgD64HUM8AZN8CYmeAsPvE0A3qEB3iUL3iMP3icCH1IAH5EDH1MCn+CAT7HAZ1TAF/jgS0LwFS74Ght8Qxl8Sw18xxP4nir4IZuGYIOgRQAaBHQIxCAiAdEiCTFiCGLFCMSJUYgX45BITEBiMQlJxBQkFTOQTMxCcjEHKcQ8pBQLkEosQYJYhtRiBdIQq5CmWIO0xAakLTYhHbEF6YptSE/sQvpiDzIQ+5ChOICMxBFkLI4hE3EKmYozyEycQ+biArIQl5CluIKsxDVkLW4gG3EL2Yo7yE7cQ/biAXIorp0lvOR98BN+M34E4eUzmCMsguKT6ZERseJYIgvRXBBqKjQnBpYpxdRmyAhbYCixNSlb4Cw4bUW75gbv21zUvcQ+i2uRoWjn1DVauVxQP9bUWd3v8Rdp6p3nUT1Y+VlRGWOt/3bzg5PSFY0kbrbbxnpVOX/GXjdfxH7Njjq1ljwPIR2GINVxwTHrXfsAvaZw4fsCG98u8cL3A3xCR1Hlq273YZ+43igSPap33vzQ9iEeILokNgODOoHiXiCY+3+tNrfm/orbr5fdXHU3ctmFgr846Cn6abMDDLtJ3PiiPj0znn6Un69z3iEAAQwwxE0EGwz6bD89/WXrH+DnB1xJPm6yf/0b/PXnX/BvvYkJ2JZDMh0wOwDo5kOgGtfe4YnK86BwCUGcBeesbkGnJ0gLwokFm/mknR2i7UcmtM4bTkYoifIXdT/QipBPPGnUZA0fPMJ+9QT6xOMKzefXyaewz09P5N7i92nzc0dIa7fJYU6PsnPxA948Khcj1eDfeeeqcUQuRmmny7kWnx8aDvNx8rv4gf2sa51fefMq2NpipiedmLW1p65XHg0ORMh49c34ijQ6Eo80++FZDkLjpAjSufRliE/kJdr8LFCNDFN5kZMZI4uZkbmdE3mVJfkZnaRcZy+4B2XD4GgUK+8gzap4SlwUsrOqgDWAlUxHlVMSCO4PhjkNhg+G5zKOIYOIcAQYAot0xPqeuwhJ+2k5QfLjUwAmgxggqAHj2aeJ9vnyQkT++eczOoW1W9q5/JXS7r4Q9lMkHekoDlihrlDusxsxe4qNkuz2W8uxmnenKTnnHu0qvX5/Llo52/TcbEYCmXJvbaosBYUVshBMt+AiJHOwqlYBaM01/ymgwUoMjAxCvg4Mm4GOcpt2lnSX9XvTuqrRskIh02xG6Z5ym3Q8ZnFHoBAJzsxOc23mhkJWaLQ0FMismm0GzPToaC5noKu0q6x7Fi+D4kxvGShkYn2ZBDTNkBXu7r/STDhsU0FpMthZAlqk/2WCncEkLBurtWPxcKhvap83rX9hdzhlcSNstOEDnkUo32MnAlkgeNJnLO6ZLLvBPQb7Sj8zFy0D9h+N/X/q4drQaRDiAq5AVbYzrqw+OlwsveEpZ/E1Y9FVW7pLnkO/+C6/Gt+cH+1kFMlEAYB8GNxYm1fN+CcEM6tuIhb2Oo9BrJbfixJx/b18e3XzS9SHG80A7WW4o3gM/KNbBvasulsV8fSGGNEsVvE8PAsQFLEckpFMvWvTHc/PG8PKOa31fsLqQ5wW7Opqt1fS+dfAM+v7XHER5foGtA6B8fDYRjekUewv0qqLsA87Lb4CdrDlqufH8XVxBqi6nbW08pOznJvdXlkKaTnoK52Wmmwa6tI8Lc0cpXl3x7taWozIva8TCWXa4/IrMK7Nz67PHg6Gf8SfxK/cgOI7km8jiQW590R4HlbvovkPWDkOMBKFdVTIHDp05Hvs8YKuLjPOEnQTK2DhGUE+ox3232XD/tf2whpZhLbHmsb/NK7+QixTJglpMgdBdqvOkiWWBM19ZhJvX2woyI+mLEKYZQYIIX0oHaA359DRjUIgLedaLZZ5oh417BofoBsC9rMrEfdzgzzUt6V8Ue3ZcmAVRE2klaRboeH/SBUCmAE/hBrwMzUPAwTxyDs6N841G7YtXReOI9OgvriHbzQIHZHbIrwTIv2JZXnAsJfZZJLLbrtQvPhCCIXIpVvV0N603OVP317nqF4IzufhxN3IoAkyV8+7H+Dx6l6QZu1IS8aOteWGdDVbBdut7r0KCXTbkkGq5ihaUoVnHXyenoXt+eEYs0bROHkzQDpKOkuCrVlVX8RZ8aKajSzGKg8hqr/flny2HxTQVxvVvVijY4DOANOuhUJCD7HT/DCpgagSqhs3+DCHd91y6DkR4HtXfWW8SvjmbJ/rj6+r34+HV8Gzsx3U0jp6bV25KgSuebzg+YdyIzW6qXCOMCsdqFCmy1i4mm1XcPNWeIeqZyLwdANfcnjH2khrCz0pV91dl0l41Nta+SD+ZOEV+HGXQ06Obn9CqPciQlFK5GMPLR3bQhqJPVyVmd0dv7IxVoXXpT0M3tntJDWanSPhJxt/AHFjIF13fPEO6EYxTSYDxEQyxDKziWEiJK0Qux3LI6vnO9AlyphlhXkKqyDNz+OpFMYqCVq3ooCSw9zbnUSEpvIFZE1u7gqGyLJ0ZBVL0PIOo2QKmc9XZ+csp5ivHIuvpQvZtG7WG4nhOMrz2l8HYjxST8Rj+VBvMWebMjSae3I00yzHr9kFjeeHhx6/fhloaU3OSWI1LzVv7Lf0uWy8+gHF5fd6AwWNzZDfBQ0jwnglYZDycwg+nYUgaQO8/6UAJDNAnWXKP2CfyN0v5+kaiEEVwPDxxzzWnrTmEC5rkfbRpdC3DIRCsrb1X370v5mow+ocVYDSz08ZoDou4FEr/VQBx4k1r0ZNGRb/1O+e8FM8PKXLRRcQzxAnjosZ7bEW44kMcXyAi67sIe1HTWQNWor2PusfoNZqtX2LFilQd3h9H+22Z2oGb4hGAL5c0EHw0dQ70HB/OgzKzKQCcOkaQsKkdaxqs764LfQ4fdz1jJAaGj0rKmpWdFr+wovO/f3zHjy4kHiV89wKqq7eEYo0IJMeRGtCuLekTr1jx5E3b8bGOkBl+qJFnwYGVqz8D7yqRguL2M9oQ0O8dPxKdjY/u53X7oC/Vi6h4CkhS9GYjr6b7Ick7RLALGNnU/AO7byO7BReaRGnmiQdOh9vNj958vSJAayfGkDF3/z0Kdhbe9ym59cgg7GWyRH4fQroFZNiYtZmxg0ulrw/3bxnr9lksvLu1HR4h1qf9+z57ONkPhqKA8aHpVjG5vQB3aNmHyewcSN4xBK+Q13jM/6xGzdhAb+h0xlqoIvRRbZw4TufKW0DokMX5PIWjAzz7iDzDclZQephWoq9xDJ/Ym9uP7Ncz5CEGEiZvSRAVwyaWwyETwv7B47YRzoooiv4ReEFeeF6wacifj6Xm88rqqrILQ3Pz+Pp+YZ4o//c/n53T8Ijb07erTSfOO/oaO84n70C9vaO3u3f+7pH5hfNYahmJOsakpNjZyRVFulm6+xUk+o9UGiCFI2a44NsSWmdJaPRi4E8+NJpm3kTBmV05kXm7T04Ya3LaY8zAo/C3YX3Uj5nv37nITjjsRWj3ujqqCvBlOJO4UoxtiW+oOturhEB+9XdInsh8D1tniXFNyki2qJBR/97uP2ZZP7E3FlUU1lSxBTLmWoL3coPCwJhuKOFRRY4QnCL85IZjSrs1N+5GVboHNllPAhc3PaRNUC+SuZdw5Lve1g1u7+F0mrWHmD54Tv6zAZYrf3uILYvqH5fjo2ykSsKDnTfIMbSCDB/Ct8jBFeQuwSOpsdZaUnRl0/FbV+1NGrx0EecY0LRtvrTZ861+H7tA/+DuftLNxXubtNMTfNNcoCQLkmW8U5oIo8hQ6lUBYce9QyiWgExl6a2KxySDT77U37+5cni0jJt+7QySyukRXKCLQlLENinVdShHIIHu3tjv82aANMadxAOPu5svfel1n1VkVbHnpTAcwqhEO3YR9pocapFk9f0bo1U78ldVrLv7rzpO5fMWf6ekECbb7UORsg+JCMpyHHGMmlxZGSxtAwn4GrFkWVSHLGFxiyqzk2zUgHAI9WrtmW7PpmoIeo7t9cmwpPghaHwxC9ybGhi2EyFZ2P1Y08ncmdeazcgSVLQk/RPeaNp4IlZ6RRfpwb0XktdYeiuzIB7v9Y0PTAsM7CVNSLPsJyw3Tcbbu7O4YQxhcVKaD11xDfczxQx7M/zG77/NSs93hCvzFKuNqzur+qukh9oCWGokyeB3LeG5wELJtA8W96GVlNT1vP1S1n1i/3E0G2IXlAQdNhoz3L0UKtFDR3e1H6OTH6nyI8r0XN5RfVjQ3rOrEL2oEmEMwR4TE3sOmsEzDM++tN6o5Kq/KmgXqNynQe6yRQfzwWN3LCGRlFjXKOwEbhJ7ys9XZl1tQoYz7+oaYPPY/S8WTlVpwjmagDvd82cd78ME2kjDVWfbb9OUATggT8qnk7HFSQZ4WR8jFUSUXb4ZHxLfbVs6o1HWMt4eWvp3n1nG31GdsI+0ihdDI2jUTIlWiCmwBDO2VbJEOCRpUmqA4eu9vQhKmDwvOWkWDAY2ffsXfnBm7K8JTdPy7ewgtCaWGsSBibwjCk8W0DBHzd28sZtE2Cqpg785sfzm+6O1LiXF2pl5wgKeI7B9gRy6LZVbtGihZMXrt4SnL8xaVne3ovTM9csnlNzkRDjVm/ZCsdlNUqIkcTo2uniKULhFPF0uIArTxFOF0PAk4n6a0Gqm8pVWR35m/8PNKmP8GdPwKi/S8+eJYcfvrp8+dXD7ev2dLr4j/o7oqA9pyDU0NSQQI02MIR6a2X9LVqIJjBQE+LHR1FOf/jw0zTyc0ztZaH4qI6Ax/4unfxVJOxfUg6trI9fSABf/8G4cTO3YHvrX/8xM8s8Z46Nzeirc52lF2yttaVjhm1DbAGmow9j6JgmjbVtCAaQe90aQ7f96CpBJMKQkGWcHgfBGwxwJNxWuhEHtSzWo2gF8Fw41qAT0MhQKsojNROONCkzYa8BR2IZyf23MkT5253kbpaavVxchSa3MDdThGv7iOwA3kgIIxjxe4Iza5V8Z6SbSej61n6NVfA68m4U5URdbrCXuMmKu4i0DOHWvXh2SDijNhPtMhGORmDmxovwSGoiippJQCEI0zUqmqc6uSus6+7ULmwX0N8AbLPOUUkP6AqgK3ugNXqdX8DjFVQBmK2IBAEQGGuWOIeUWrI4ialhZc/I4mSwQzM42Q8TJPjA3vIZ2RpWErNkMSn1radeqfcEGrqcYYqj+wsU9+z7uWXUBHmk7wkU/vQ4U+xIHN0hAv9ZxwhiZ/gI49bTEh3p/JHYET7dSUlbL4zL8GEH6Rif8REO9LgRifvDjFcZ+CbC8j7LAE5at393JJlHkpxo2BkOifVrNhujQPvmtfpEDuDMRjMNUA1EWFYUQ7MLnIT2mQwVQw7V07MInr9DU5DOOjgKsp0QHYJHUOOQrnG3h7d+fLoyEk+S31vJggXCLWQwAMGJEhgEO8oHEDizABw87h5lt+1+3388C4/t63r2zcr+FP30EZ0wsV50+YZ2RrnEOJdgJNSgtfK5PfmHSs6SMplSllwV7Seb/TevCN2GGvP+zvaTRauwNKZUypSzQPAKfbmy/FGCazM4aORdrlqlV6lQjipfe7vYs9MTl4xT5trEz/TXuksk7lp/kXCyUo7T4zoP3nLlqlHk766VSLS5xEG1s0TDdqvqaRY291S5sfGJO6trb90SL5n4ICa/Jj/m8wNaEI+blx9eLuC9zQuiPQBb35gnNb+YOAum782OQmXxA3z6ozAYOtTq1WldNtiRvNmKvQ5hg3Q4btwA+pCLrcMXeSwjU7etOsa9ML/nollViBoEYdmEJRFhCtp3yr6pKc6iMYMWwHCan0wchel9u10rtHiEz3joiUOHWrw5VZgDxsZufb70vNvgeQCyZzCWb8L3w6TBCiZFHLXoHq4X70PxbPjJjAqWBhtx+MrccE0gPzkkhqIxGFKcooN1/EBVWHYFnIBff8fe7GddNnavd6ugSJbMixJJ0Gpv5NnZyPTuUoq3ghUJJQLivo4IPZ+vj5DHF98jZ2LKLTXO6QmrNIdfHkuLFRQ6Zbnq50QI9EX81Cryt5SVLMJ1+7edLs5ZLnuAr9fzQeDQOI6kjJD6cmJrYqyhwEzGjw+YfPR2dCu6HfXqt72dyaAirGNiazi+UviSqGwZ+LFtUO2Z2I5e01isrUtsTPiOZHeHpJnVNpmhtpkzJhU7bK01MeGxBBwxxl2tSaGHq04roehfG8ONxV9b5yVjMmVqgfBSR2JZi9uA0DINIobMvw089tjku5c0+itPOPNxh9bO6pHE29GcdSqNAn/NWZajt3ng6MDAKGmvHdZuc/qvOltrMll7dXs7/eMB6rBi9dMW1TPkEtSSZ7EsKM53rXmhpbVgYPlAUX/RIgFvAVie6Jjpwd/nwY0Tc9jUU9JHtMyPdqN2aHIzgsebjMYSgJu0pSSXm83hZHNzRwQMPrDbP/J6nZ3FGq1Gs/639vczeMYObneEUBnParWBr9ug8C524YZtmqnRESoKHGWbaxmPgTT2nOaAbLO5IS/fSlXjkHXbdFtrhBMZE+FJx2qeva656N4+qw1pKNTK5YnMWrT6YHB+tqmeBs0POMk1F3WPet5As24NwGA2v5nh8A6Gy1MhdZCM2QyyG3qrpJEqyAZcreAnCsDd8FkAPYTYEIlGIYwfvB7Umi6GsV+g5ygCqyFqOToHjwbXf9BIObkH3cr2GwM1Ig4pqntTZYkMHYSKfAR6hpVAlsO/A/dWBrdOeFc/ztA5iCCN0MIFqH6o2/wPgHSzDiOroK0QkanQxhzXQm/caeXoIPQACRbQJREi4jh0kKFRickeqAO55kNTI9qp0F2/HmjOytEFKDDLtFApg/rtHHiIzlDS/b/sNw08ia/MycEKvllYQ28AwHTL58drAii+XZAKFsD18oAAiDnLoc787/8/SP+nSH7uShwd38o4+35mM6gLXn9KBZh4QFvd4O8WQbGsj3hCW1+hq1CXKJsgh81m3ExTaioYlREA1EMA5Kj5H38zTXhAyCgA4q5kFdjLT3/bJ34gv2aDZary94PZIAIAZ9hKgAENAQDeKgXgH0rk4PwclUCAZubgf8pUCcUWGEosyLEVsAbOsTVAA2ZsD3yA/8ojQARpAAIwhCWAAQyYeqDgFrMoyMJIISxaYyOBHdgcGwUwoD+2FUgGFzfGGngWKP8G8Zow34ArQbHh7i/sATh7wqbvNoiTcQgIrARMM543eeY2RWxjmWJzQCgQAjWJ6Qm0dBORtLW+bmlPXacpLgziNWG+AVeCYnpzMtIH4IyhPmkNPR0b5dQhRpb4lYDhx3NPN8/cJmLxtnEaZIoNB3yQEQWM6AMnuuYJNCYdEw5N2mLdap9lxV3HXNy/eGW00Fx+x1lFRkGFGg1adP959WONMcEUM8wBRJhQxoVU2ljngzCKkzTLi7Kqm7brh3Gal3Xbj/O6n/f7/VQQRulMNpcvFEvlSrVWbzRb7U631x+89LJxVh1bU0FZC3as7ZfVY97pYHMD2b/AHitX6chFhZHWYNuv6gN6+kqT3EYVQh1XnTHhGq6v7Vd0p/maqzzp9Tqqse1rUzmq9vza9IC7lVewCsPEFfxJoRn5a9P2I5tgxkpP39sKAcweoO1KBoYVW2gq29xYTSuurFQujTfejZqfkaPKv0gMK/5aeh3SShe+K+EExHT/1j70DD4i3YCmGAGNEk+YPyQ1XKDlpskNDOwFVlNkgdqjx2ahqbBOA9GX+Daocw9E+fA6M+JBCeGtPmzbf+b6J+vMu4l8J9GuwjvmJw2gQ81nAxd0W5yDLDRfcaqkONT84feG+VSD1ltx6ynIhwwoWmsN+88qpgB5lFPEo8t1PsTFhkfyCbFXoSo3sN8dK0MwvntsNlIQdooI4Yf0OdT2i88UjRRIGOwGyLwXe5xgYupWNJPMDXZZY9vOHLiw79HOWgAAAAA=") format("woff2");
        }

        .wticons {
            line-height: 1;
        }

            .wticons:before {
                font-family: wticons !important;
                font-style: normal;
                font-weight: normal !important;
                vertical-align: top;
            }

        .wticon-account:before {
            content: "\f101";
        }

        .wticon-add:before {
            content: "\f102";
        }

        .wticon-cardResizeDrag:before {
            content: "\f103";
        }

        .wticon-casual:before {
            content: "\f104";
        }

        .wticon-check:before {
            content: "\f105";
        }

        .wticon-checkSmall:before {
            content: "\f106";
        }

        .wticon-chevron:before {
            content: "\f107";
        }

        .wticon-copy:before {
            content: "\f108";
        }

        .wticon-copySmall:before {
            content: "\f109";
        }

        .wticon-dismiss:before {
            content: "\f10a";
        }

        .wticon-downChevron:before {
            content: "\f10b";
        }

        .wticon-error:before {
            content: "\f10c";
        }

        .wticon-expand:before {
            content: "\f10d";
        }

        .wticon-feedback:before {
            content: "\f10e";
        }

        .wticon-filledDownArrow:before {
            content: "\f10f";
        }

        .wticon-find:before {
            content: "\f110";
        }

        .wticon-formal:before {
            content: "\f111";
        }

        .wticon-gift:before {
            content: "\f112";
        }

        .wticon-grayLogo:before {
            content: "\f113";
        }

        .wticon-ignore:before {
            content: "\f114";
        }

        .wticon-info:before {
            content: "\f115";
        }

        .wticon-leftChevron:before {
            content: "\f116";
        }

        .wticon-logo:before {
            content: "\f117";
        }

        .wticon-love:before {
            content: "\f118";
        }

        .wticon-noRecommendations:before {
            content: "\f119";
        }

        .wticon-paragraphRewrite:before {
            content: "\f11a";
        }

        .wticon-paste:before {
            content: "\f11b";
        }

        .wticon-pin:before {
            content: "\f11c";
        }

        .wticon-premium:before {
            content: "\f11d";
        }

        .wticon-premiumDetail:before {
            content: "\f11e";
        }

        .wticon-premiumFull:before {
            content: "\f11f";
        }

        .wticon-recommendationLight:before {
            content: "\f120";
        }

        .wticon-recommendationLightCard:before {
            content: "\f121";
        }

        .wticon-recommendationLightNoSuggestions:before {
            content: "\f122";
        }

        .wticon-refine:before {
            content: "\f123";
        }

        .wticon-rewrite:before {
            content: "\f124";
        }

        .wticon-rightChevron:before {
            content: "\f125";
        }

        .wticon-rocket:before {
            content: "\f126";
        }

        .wticon-sentenceExamples:before {
            content: "\f127";
        }

        .wticon-settings:before {
            content: "\f128";
        }

        .wticon-shorten:before {
            content: "\f129";
        }

        .wticon-tutorial:before {
            content: "\f12a";
        }

        .wticon-unlock:before {
            content: "\f12b";
        }

        .wticon-warn:before {
            content: "\f12c";
        }

        .wticon-WordtuneButton:before {
            content: "\f12d";
        }

        .wticon-x:before {
            content: "\f12e";
        }

        /*# sourceMappingURL=data:application/json;base64,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 */
    </style>
</head>

<body id="top" style="">
    <div class="main-container">
        <div class="banner">
            <div class="container">
                <header>
                    <div class="nav-header">
                        <nav>
                            <div id="mySidenav" class="sidenav">
                                <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">×</a>
                                <ul class="navbar">
                                    <li class="dropdown">
                                        <a href="/en/what-we-do">What We Do</a>
                                        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                                        <i class="d-arrow-hov"><img src="http://www.dev.actnow.org.uk/../images/d-arrow-hov.png" alt=""></i>
                                        <div class="dropdown-content">
                                            <div class="linkset1">
                                                <div class="mobilemenuback">Back</div>
                                                <div class="header">
                                                    <h2><span>What We Do</span></h2>
                                                </div>
                                                <div class="row">
                                                    <div class="column submenu">
                                                        <!-- <div class="linkset1"><div class="mobilemenuback">Back</div> -->
                                                        <h3><a href="http://www.dev.actnow.org.uk/category/gdpr">GDPR</a></h3>
                                                        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                                                        <ul>
                                                            <div class="linkset1"><div class="submobilemenuback">Back</div>

                                                            <li class="submenuBar">
                                                                <a href="http://www.dev.actnow.org.uk/category/gdpr" class="child2">Public Courses</a>
                                                                <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                                                                <ul>
                                                                    <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
                                                                    <li><a href="http://www.dev.actnow.org.uk//category/gdpr/category=1&amp;course-type=one_day_courses">Full Day Workshops</a></li>
                                                                    <li><a href="http://www.dev.actnow.org.uk/course/gdpr-practitioner-certificate">GDPR Practitioner Certificate</a></li>
                                                    </div>
                                </ul>
                                </li>


                                <li class="submenuBar">
                                    <a href="http://www.dev.actnow.org.uk//category/gdpr/category=1&amp;course-type=webinars" class="child2">Online Training</a>
                                    <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                                    <ul>
                                        <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
                                        <li><a href="http://www.dev.actnow.org.uk//category/gdpr/category=1&amp;course-type=webinars">Live Webinars</a></li>
                                        <li><a href="http://www.dev.actnow.org.uk//en/webinar-recordings">Webinar Recordings</a></li>
                                        <li><a href="http://www.dev.actnow.org.uk//product/gdpr-e-learning">GDPR E-Learning Course</a></li>
                                        <li><a href="http://www.dev.actnow.org.uk//product/foundation-certificate-in-information-governance">Foundation Certificate in Information Governance</a></li>
                            </div>
                            </ul>
                            </li>


                            <li class="submenuBar">
                                <a href="http://www.dev.actnow.org.uk//en/products" class="child2">Products</a>
                                <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                                <ul>
                                    <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
                                    <li><a href="http://www.dev.actnow.org.uk//product/gdpr-handbook">GDPR Handbook</a></li>
                                    <li><a href="http://www.dev.actnow.org.uk//product/gdpr-helpline">GDPR Helpline</a></li>
                                    <li><a href="http://www.dev.actnow.org.uk//product/policy-pack">GDPR Policy Pack</a></li>
                                    <li><a href="http://www.dev.actnow.org.uk//product/led-policy-pack">Law Enforcement Policy Pack</a></li>
                    </div>
                    </ul>
                    </li>


                    <li class="submenuBar">
                        <a href="http://www.dev.actnow.org.uk//en/inhouse-training-enquiry-form" class="child2">Inhouse Training and Consultancy</a>
                        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                        <ul>
                            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
                            <li><a href="http://www.dev.actnow.org.uk//en/inhouse-training-enquiry-form">Bespoke Workshops</a></li>
                            <li><a href="http://www.dev.actnow.org.uk//en/audit">GDPR Audit and Healthcheck</a></li>
            </div>
            </ul>
            </li>

        </div>
        </ul>
        <!-- </div> -->
    </div>
    <div class="column submenu">
        <!-- <div class="linkset1"><div class="mobilemenuback">Back</div> -->
        <h3><a href="http://www.dev.actnow.org.uk//category/foi">FOI</a></h3>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="submobilemenuback">Back</div>

            <li class="submenuBar">
                <a href="http://www.dev.actnow.org.uk//category/foi" class="child2">Public Courses</a>
                <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                <ul>
                    <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
                    <li><a href="http://www.dev.actnow.org.uk//category/foi/category=46&amp;course-type=one_day_courses">Full Day Workshops</a></li>
                    <li><a href="http://www.dev.actnow.org.uk//course/foi-practitioner-certificate">FOI Practitioner Certificate</a></li>
                    <li><a href="http://www.dev.actnow.org.uk/course/foisa-practitioner-certificate_1">FOISA Practitioner Certificate</a></li>
    </div>
    </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk//category/foi/category=46&amp;course-type=webinars" class="child2">Online Training</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk//category/foi/category=46&amp;course-type=webinars">Live Webinars</a></li>
            <li><a href="http://www.dev.actnow.org.uk//en/webinar-recordings">Webinar Recordings</a></li>
            </div>
        </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk//en/products" class="child2">Products</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk//product/foi-helpline">FOI Helpline</a></li>
            </div>
        </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk//en/inhouse-training-enquiry-form" class="child2">Inhouse Training and Consultancy</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk//en/inhouse-training-enquiry-form">Bespoke Workshops</a></li>
            <li><a href="http://www.dev.actnow.org.uk//en/audit">FOI Audit and Healthcheck</a></li>
            </div>
        </ul>
    </li>

    </div>
    </ul>
    <!-- </div> -->
    </div>
    <div class="column submenu">
        <!-- <div class="linkset1"><div class="mobilemenuback">Back</div> -->
        <h3><a href="http://www.dev.actnow.org.uk//category/cyber">Cyber</a></h3>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="submobilemenuback">Back</div>

            <li class="submenuBar">
                <a href="http://www.dev.actnow.org.uk//category/cyber" class="child2">Cyber Security</a>
                <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                <ul>
                    <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
                    <li><a href="http://www.dev.actnow.org.uk//category/cyber/category=57&amp;course-type=one_day_courses">Full Day Workshops</a></li>
                    <li><a href="http://www.dev.actnow.org.uk//en/audit">ISO 27001 Audit</a></li>
    </div>
    </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk//category/ripa" class="child2">Regulation of Investigatory Powers Act</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk//category/ripa">Full Day Workshops</a></li>
            <li><a href="http://www.dev.actnow.org.uk//category/ripa/category=56&amp;course-type=webinars">Live Webinars</a></li>
            <li><a href="http://www.dev.actnow.org.uk//product/ripa-helpline">RIPA Helpline</a></li>
            <li><a href="http://www.dev.actnow.org.uk//product/ripa-toolkit">RIPA Toolkit</a></li>
            <li><a href="http://www.dev.actnow.org.uk//en/audit">RIPA Audit and Healthcheck</a></li>
            </div>
        </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk//category/bribery" class="child2">Bribery Act</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk//course/fundamentals-of-the-bribery-act-2010">Fundamentals of the Bribery Act</a></li>
            </div>
        </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk//en/inhouse-training-enquiry-form" class="child2">Inhouse Training and Consultancy</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk//en/inhouse-training-enquiry-form">Bespoke Workshops</a></li>
            </div>
        </ul>
    </li>

    </div>
    </ul>
    <!-- </div> -->
    </div>

    </div>
    </div>
    </div>
    </li>
    <li class="dropdown">
        <a href="/en/our-services">Our Services</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <i class="d-arrow-hov"><img src="http://www.dev.actnow.org.uk/../images/d-arrow-hov.png" alt=""></i>
        <div class="dropdown-content">
            <div class="linkset1">
                <div class="mobilemenuback">Back</div>
                <div class="header">
                    <h2><span>Our Services</span></h2>
                </div>
                <div class="row">
                    <div class="column submenu">
                        <!-- <div class="linkset1"><div class="mobilemenuback">Back</div> -->
                        <h3><a href="http://www.dev.actnow.org.uk//category/gdpr/category=1,46,56,57,58&amp;course-type=one_day_courses">Courses</a></h3>
                        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                        <ul>
                            <div class="linkset1"><div class="submobilemenuback">Back</div>

                            <li class="submenuBar">
                                <a href="http://www.dev.actnow.org.uk//category/gdpr/category=1,46,56,57,58&amp;course-type=one_day_courses" class="child2">Full Day Courses</a>
                                <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                                <ul>
                                    <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
                                    <li><a href="http://www.dev.actnow.org.uk//category/gdpr/category=1&amp;course-type=one_day_courses">GDPR Workshops</a></li>
                                    <li><a href="http://www.dev.actnow.org.uk//category/foi/category=46&amp;course-type=one_day_courses">FOI Workshops</a></li>
                                    <li><a href="http://www.dev.actnow.org.uk//category/cyber">Cyber Security Workshops</a></li>
                                    <li><a href="http://www.dev.actnow.org.uk//category/ripa">RIPA Workshops</a></li>
                    </div>
                    </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk//category/gdpr/category=1,46,56,57,58&amp;course-type=certificate_courses" class="child2">Certificate Courses</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk/course/gdpr-practitioner-certificate">GDPR Practitioner Certificate</a></li>
            <li><a href="http://www.dev.actnow.org.uk/course/foi-practitioner-certificate">FOI Practitioner Certificate</a></li>
            <li><a href="http://www.dev.actnow.org.uk/course/foisa-practitioner-certificate_1">FOISA Practitioner Certificate</a></li>
            </div>
        </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk//en/inhouse-training-enquiry-form" class="child2">Inhouse Training and Consultancy</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk//en/inhouse-training-enquiry-form">Request a Quote</a></li>
            <li><a href="http://www.dev.actnow.org.uk//en/audit">GDPR Audit and Healthcheck</a></li>
            <li><a href="http://www.dev.actnow.org.uk//en/audit">FOI Audit and Healthcheck</a></li>
            <li><a href="http://www.dev.actnow.org.uk//en/audit">RIPA Audit and Healthcheck</a></li>
            <li><a href="http://www.dev.actnow.org.uk//en/audit">ISO 27001 Audit</a></li>
            </div>
        </ul>
    </li>

    </div>
    </ul>
    <!-- </div> -->
    </div>
    <div class="column submenu">
        <!-- <div class="linkset1"><div class="mobilemenuback">Back</div> -->
        <h3><a href="http://www.dev.actnow.org.uk//category/gdpr/category=1,46,56,57,58&amp;course-type=webinars">Online Training</a></h3>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="submobilemenuback">Back</div>

            <li class="submenuBar">
                <a href="http://www.dev.actnow.org.uk//category/gdpr/category=1,46,56,57,58&amp;course-type=webinars" class="child2">Live Webinars</a>
                <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                <ul>
                    <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
                    <li><a href="http://www.dev.actnow.org.uk//category/gdpr/category=1&amp;course-type=webinars">GDPR</a></li>
                    <li><a href="http://www.dev.actnow.org.uk//category/foi/category=46&amp;course-type=webinars">FOI</a></li>
                    <li><a href="http://www.dev.actnow.org.uk//category/ripa/category=56&amp;course-type=webinars">RIPA</a></li>
                    <li><a href="http://www.dev.actnow.org.uk//en/inhouse-training-enquiry-form">Bespoke Webinars</a></li>
    </div>
    </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk/en/webinar-recordings" class="child2">Webinar Recordings</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk/en/webinar-recordings">GDPR</a></li>
            <li><a href="http://www.dev.actnow.org.uk/en/webinar-recordings">FOI</a></li>
            <li><a href="http://www.dev.actnow.org.uk/en/webinar-recordings">RIPA</a></li>
            </div>
        </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk//product/gdpr-e-learning" class="child2">E-Learning</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk/product/gdpr-e-learning">GDPR</a></li>
            <li><a href="http://www.dev.actnow.org.uk//product/foundation-certificate-in-information-governance">Foundation Certificate in Information Governance</a></li>
            </div>
        </ul>
    </li>

    </div>
    </ul>
    <!-- </div> -->
    </div>
    <div class="column submenu">
        <!-- <div class="linkset1"><div class="mobilemenuback">Back</div> -->
        <h3><a href="http://www.dev.actnow.org.uk/en/products">Products</a></h3>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="submobilemenuback">Back</div>

            <li class="submenuBar">
                <a href="http://www.dev.actnow.org.uk/" class="child2">Helplines</a>
                <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
                <ul>
                    <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
                    <li><a href="http://www.dev.actnow.org.uk/product/gdpr-helpline">GDPR</a></li>
                    <li><a href="http://www.dev.actnow.org.uk/product/foi-helpline">FOI</a></li>
                    <li><a href="http://www.dev.actnow.org.uk/product/ripa-helpline">RIPA</a></li>
    </div>
    </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk/" class="child2">Policy Packs</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk/product/policy-pack">GDPR</a></li>
            <li><a href="http://www.dev.actnow.org.uk/product/led-policy-pack">Law Enforcement</a></li>
            </div>
        </ul>
    </li>


    <li class="submenuBar">
        <a href="http://www.dev.actnow.org.uk/" class="child2">Publications</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <ul>
            <div class="linkset1"><div class="lastsubmobilemenuback">Back</div>
            <li><a href="http://www.dev.actnow.org.uk/product/gdpr-handbook">GDPR Handbook</a></li>
            <li><a href="http://www.dev.actnow.org.uk/product/ripa-toolkit">RIPA Toolkit</a></li>
            </div>
        </ul>
    </li>

    </div>
    </ul>
    <!-- </div> -->
    </div>

    </div>
    </div>
    </div>
    </li>
    <li class="dropdown">
        <a href="/en/about-us">About Us</a>
        <i class="dropdown-arrow"><img src="http://www.dev.actnow.org.uk/../images/d-arrow.png" alt=""></i>
        <i class="d-arrow-hov"><img src="http://www.dev.actnow.org.uk/../images/d-arrow-hov.png" alt=""></i>
        <div class="dropdown-content">
            <div class="linkset1">
                <div class="mobilemenuback">Back</div>
                <ul class="noSubmenu">
                    <li><a href="/en/testimonials">Testimonials</a></li>
                    <li><a href="/en/clients">Clients</a></li>
                    <li><a href="/en/personnel">Our Team</a></li>
                    <li><a href="/en/mission-statement">Our Mission Statement</a></li>
                    <li><a href="/en/act-now-foundation">Act Now Foundation</a></li>
                </ul>
            </div>
        </div>
    </li>
    <li class="dropdown">
        <a href="/en/blogs">Latest News</a>
    </li>
    <li class="dropdown">
        <a href="/en/contact-us">Contact Us</a>
    </li>
    </ul>
    </div>
    <span class="openClass" onclick="openNav()">☰</span>
    <div class="logo">
        <a href="/"><img src="http://www.dev.actnow.org.uk/uploads/logo/6140372logo.png" alt="logo"></a>
    </div>
    <div class="clear"></div>
    </nav>
    <div class="login-header">
        <p class="train-P">Training and Consultancy in Data Protection, Freedom of Information and Cyber Security Since 2002</p>
        <ul class="login-UL">
            <li class="login"><a href="/login">Log In</a></li>
            <!-- cart section -->
            <li class="cart" id="headerCartId">
                <a href="javascript:void(0)" class="cartCount" id="cartCount">0</a>
                <div class="cartDiv">
                    <h4>Your cart</h4>
                    <p id="emptyCartMsg">Your cart is currently empty.</p>		<div id="hcMessage" style="display: none;"></div>
                    <div class="cartList" style="display: none;">
                        <ul class="courseList">
                        </ul>

                        <div class="checkOut">
                            <div class="checkAmount">

                                <div class="totalDiv">
                                    <span>Sub Total</span>
                                    <strong class="priceSpan">£<span id="cartTotal-header">0.00</span></strong>
                                </div>
                                <div class="totalDiv">
                                    <span>Vat</span>
                                    <strong class="priceSpan">£<span id="vatTotal-header">0.00</span></strong>
                                </div>
                                <div class="totalDiv">
                                    <span>Grand Total</span>
                                    <strong class="priceSpan">£<span id="finalTotal-header">0.00</span></strong>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="viewCartBtn">
                        <a href="/cart" class="checkB">View Cart</a>
                        <button type="button" onclick="updateCartHeader(this)" name="update-headerCart" id="update-headerCart" class="checkB">Update Cart</button>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    </div>    </header>

    <div class="sliderWrapper" id="sliderWrapper">
        <div class="sliderContainer">
            <div class="slider responsive slick-initialized slick-slider">

                <div class="slick-list draggable" tabindex="0">
                    <div class="slick-track" style="opacity: 1; width: 5935px; transform: translate3d(-3561px, 0px, 0px);">
                        <div class="sliderInfoWrapper bannerSlider slider-3 slick-slide slick-cloned" style="width: 1187px;">
                            <div class="sliderInfoContainer">
                                <a href="http://www.dev.actnow.org.uk/course/introduction-to-cyber-security">
                                    <img src="http://www.dev.actnow.org.uk/uploads/banners/5d90cb8e974baHomePage Banner Image With Text (CYBER).jpg" alt="banner">
                                </a>
                                <div class="container">
                                    <div class="bannerText  textBG lefttop " style=" background-color:rgba(0, 0, 0, 0)">
                                    </div>
                                </div>
                            </div>
                        </div><div class="sliderInfoWrapper bannerSlider slider-1 slick-slide" style="width: 1187px;">
                            <div class="sliderInfoContainer">
                                <a href="http://www.dev.actnow.org.uk/course/gdpr-practitioner-certificate">
                                    <img src="http://www.dev.actnow.org.uk/uploads/banners/5d90cb4a2619bHomePage Banner Image With Text (GDPR).jpg" alt="banner">
                                </a>
                                <div class="container">
                                    <div class="bannerText  textBG lefttop " style=" background-color:rgba(0, 0, 0, 0)">
                                    </div>
                                </div>
                            </div>
                        </div><div class="sliderInfoWrapper bannerSlider slider-2 slick-slide" style="width: 1187px;">
                            <div class="sliderInfoContainer">
                                <a href="http://www.dev.actnow.org.uk/course/foi-practitioner-certificate">
                                    <img src="http://www.dev.actnow.org.uk/uploads/banners/5d90cb625eb2cHomePage Banner Image With Text (FOI).jpg" alt="banner">
                                </a>
                                <div class="container">
                                    <div class="bannerText  textBG lefttop " style=" background-color:rgba(0, 0, 0, 0)">
                                    </div>
                                </div>
                            </div>
                        </div><div class="sliderInfoWrapper bannerSlider slider-3 slick-slide slick-active" style="width: 1187px;">
                            <div class="sliderInfoContainer">
                                <a href="http://www.dev.actnow.org.uk/course/introduction-to-cyber-security">
                                    <img src="http://www.dev.actnow.org.uk/uploads/banners/5d90cb8e974baHomePage Banner Image With Text (CYBER).jpg" alt="banner">
                                </a>
                                <div class="container">
                                    <div class="bannerText  textBG lefttop " style=" background-color:rgba(0, 0, 0, 0)">
                                    </div>
                                </div>
                            </div>
                        </div><div class="sliderInfoWrapper bannerSlider slider-1 slick-slide slick-cloned" style="width: 1187px;">
                            <div class="sliderInfoContainer">
                                <a href="http://www.dev.actnow.org.uk/course/gdpr-practitioner-certificate">
                                    <img src="http://www.dev.actnow.org.uk/uploads/banners/5d90cb4a2619bHomePage Banner Image With Text (GDPR).jpg" alt="banner">
                                </a>
                                <div class="container">
                                    <div class="bannerText  textBG lefttop " style=" background-color:rgba(0, 0, 0, 0)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




            </div>
            <button type="button" class="slick-prev" style="display: inline-block;">Previous</button><button type="button" class="slick-next" style="display: inline-block;">Next</button>
        </div>
    </div>
    </div>
    <!-- End of body section HTML codes -->
    <div class="GDPR">
        <div class="GDPR-tab">
            <div class="left-container">
                <div class="tabData">
                    <div class="tab-list">
                        <ul>
                            <li><a href="javascript:void(0);" class="active" onclick="switchBanner(this)" data="slider-1">GDPR Practitioner Certificate</a></li>
                            <li><a href="javascript:void(0);" onclick="switchBanner(this)" data="slider-2">FOI Practitioner Certificate</a></li>
                            <li><a href="javascript:void(0);" onclick="switchBanner(this)" data="slider-3">Introduction to Cyber Security</a></li>
                        </ul>
                    </div>
                    <div class="searchSection">
                        <form class="searchF" id="searchForm" action="/search" method="post">
                            <span id="error-search" style="display: none;"></span>
                            <input type="hidden" name="_token" value="8r2uxFROsckZURPZ2c7hnxMOTShTJvvJBuLPFhnq">	<div class="row">
                                <input type="text" name="search" id="search" placeholder="Search">
                                <input type="submit" name="submit_search" class="searchBtn">
                                <!-- <button name="search" class="searchBtn">set	</button> -->
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <div class="innercontent gdprfilterpage categoryFilter">
        <div class="whiteBG"></div>
        <div class="contentWrapper">
            <div class="courseData gdprfilter  landTrain">
                <div class="left-course">
                    <div class="gdpr-filter-wrap">
                        <div class="gdpr-filter-result">
                            <div class="categoryList">
                                <div class="left-Cat-Img">
                                    <img src="http://www.dev.actnow.org.uk/uploads/categories/444x302/5d9280f1a87bbAct Now Website Images10.jpg" alt="FOI image">
                                </div>
                                <div class="rightDesc">
                                    <h2>FOI</h2>
                                    <p>The Freedom of Information Act provides access to information held by public authorities</p>
                                </div>
                            </div>
                            <div class="filter-inr-wrap">
                                <div class="filter-result-right">
                                    <h2>Filter</h2>
                                    <a class="filter-toggle hidden-lg hidden-md active" href="javascript:;" id="filterToggle">Filter</a>
                                    <div id="catlogFilters" class="catalog-filters">
                                        <div class="filter-item">
                                            <div class="filter-collapse"></div>
                                        </div>
                                        <div class="resetDiv"><a href="/category/foi">Reset<i class="fa fa-share" aria-hidden="true"></i></a></div>

                                        <ul class="select-cat" id="filtered_list">
                                            <li onclick="delete_element(this)" class="course_type_filtered_list" id="course_type_selected_filter" name="Webinars">Webinars</li>
                                        </ul>

                                        <div class="filter filter-item">
                                            <h3 class="filter-heading">
                                                <a data-toggle="collapse" aria-expanded="" class="collapsed" data-id="collapse21">Subject<span class="pricehide icon-plus"></span></a>
                                            </h3>
                                            <div id="collapse21" class="filter-collapse collapse" aria-expanded="">
                                                <ul class="checkList">
                                                    <li><input type="checkbox" class="cat_filter lvl_one_category" id="GDPR" value="1" name="select"><span>GDPR</span></li>
                                                    <li><input type="checkbox" class="cat_filter lvl_one_category" id="FOI" value="46" name="select" checked="" disabled=""><span>FOI</span></li>
                                                    <li><input type="checkbox" class="cat_filter lvl_one_category" id="RIPA" value="56" name="select"><span>RIPA</span></li>
                                                    <li><input type="checkbox" class="cat_filter lvl_one_category" id="Cyber" value="57" name="select"><span>Cyber</span></li>
                                                    <li><input type="checkbox" class="cat_filter lvl_one_category" id="Bribery" value="58" name="select"><span>Bribery</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="filter filter-item">
                                            <h3 class="filter-heading">
                                                <a data-toggle="collapse" aria-expanded="" class="collapsed" data-id="collapse21">Location<span class="pricehide icon-plus"></span></a>
                                            </h3>
                                            <div id="collapse21" class="filter-collapse collapse" aria-expanded="">
                                                <ul class="checkList">
                                                    <li><input type="checkbox" class="location_filter" id="location_Act Now" value="Act Now" name="select"><span>Act Now</span></li>
                                                    <li><input type="checkbox" class="location_filter" id="location_Belfast" value="Belfast" name="select"><span>Belfast</span></li>
                                                    <li><input type="checkbox" class="location_filter" id="location_Birmingham" value="Birmingham" name="select"><span>Birmingham</span></li>
                                                    <li><input type="checkbox" class="location_filter" id="location_Bristol" value="Bristol" name="select"><span>Bristol</span></li>
                                                    <li><input type="checkbox" class="location_filter" id="location_Edinburgh" value="Edinburgh" name="select"><span>Edinburgh</span></li>
                                                    <li><input type="checkbox" class="location_filter" id="location_Glasgow" value="Glasgow" name="select"><span>Glasgow</span></li>
                                                    <li><input type="checkbox" class="location_filter" id="location_Leeds" value="Leeds" name="select"><span>Leeds</span></li>
                                                    <li><input type="checkbox" class="location_filter" id="location_London" value="London" name="select"><span>London</span></li>
                                                    <li><input type="checkbox" class="location_filter" id="location_Manchester" value="Manchester" name="select"><span>Manchester</span></li>
                                                    <li><input type="checkbox" class="location_filter" id="location_Manchester Airport" value="Manchester Airport" name="select"><span>Manchester Airport</span></li>
                                                    <li><input type="checkbox" class="location_filter" id="location_Online" value="Online" name="select"><span>Online</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="filter filter-item">
                                            <h3 class="filter-heading"><a data-toggle="collapse" aria-expanded="" class="collapsed" data-id="collapse21">Course Type<span class="pricehide icon-plus"></span></a></h3>
                                            <div id="collapse7" class="filter-Input" aria-expanded="">
                                                <select id="course_type_filter" name="course_type_filter">
                                                    <option selected="" value="">Course Type</option>
                                                    <option value="one_day_courses">One Day Courses</option>
                                                    <option value="certificate_courses">Certificate Courses</option>
                                                    <option value="webinars">Webinars</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="filter filter-item">
                                            <h3 class="filter-heading">Date</h3>
                                            <div id="collapse4" class="filter-Input" aria-expanded="">
                                                <label>From:</label>
                                                <input type="text" id="from_date" name="from_date" class="filterDate hasDatepicker">
                                                <label>To:</label>
                                                <input type="text" id="to_date" name="to_date" class="filterDate hasDatepicker">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="filter-result-left">
                                    <!-- <div class="head-wrap">
                                        <h3>Course Name</h3>
                                    </div> -->
                                    <div class="topSort" style="display: none;">
                                        <div class="pagi-Left">
                                        </div>
                                        <ul class="rightSort">
                                            <li>
                                                <select id="sort_by_filter" class="sort_by_filter">
                                                    <option selected="" value="" disabled="">Sort By</option>
                                                    <option value="course">Course Title</option>
                                                    <option value="category">Category</option>
                                                    <option value="date">Date</option>
                                                    <option value="location">Location</option>
                                                    <option value="cost">Cost</option>
                                                </select>
                                            </li>
                                        </ul>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="loadingGif"><img src="http://www.dev.actnow.org.uk/images/loading-2.gif"></div>
                                    <div id="replace_div" class="hide_sort" >
                                        <span id="emptySpan"></span>
                                        <strong>No courses available</strong>
                                        <div class="clear"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grey-bg"></div>
    </div>
    <input type="hidden" name="_token" value="8r2uxFROsckZURPZ2c7hnxMOTShTJvvJBuLPFhnq">
    <footer>
        <!-- <footer> -->
        <div class="leftFooter">
            <div class="leftList">
                <ul class="whatDo">
                </ul>
            </div>
            <div class="footerContent">
                <p class="fullP">Our Full Privacy Policy can be read <a href="/en/privacy-policy">here</a></p>
                <p>VAT Number 830081858</p>
                <p>Company registered England and Wales (Company No. 04524979)</p>
                <!--<p>Date 08-29-2022 12:08:34</p>-->
            </div>
        </div>
        <div class="rightfooter">
            <ul class="socialMedia">
                <li class="twitter"><a href="https://twitter.com/actnowtraining" target="_blank" id="twitter_link"><img src="http://www.dev.actnow.org.uk/images/twitter.png" alt="twitter"></a></li>
                <li class="linkedin"><a href="https://in.linkedin.com/company/act-now-training-ltd" target="_blank" id="linkedin_link"><img src="http://www.dev.actnow.org.uk/images/linkedin.png" alt="linkedin"></a></li>
            </ul>
            <div class="subscribe">
                <p><strong>SUBSCRIBE TO ACT NOW</strong>Receive monthly special offers and updates on new products.</p>
                <div class="row">
                    <form action="#" method="POST" name="subscribeFrm" id="subscribeFrm">
                        <input type="hidden" name="_token" value="8r2uxFROsckZURPZ2c7hnxMOTShTJvvJBuLPFhnq">				<input type="text" onkeypress="return noenter(this)" name="subscribeEmail" placeholder="Enter your email address" id="subscribeEmail">
                        <div id="MsgSubscribe" style="display: none;"></div>

                    </form>
                    <input type="button" name="SubmitSubscribe" class="submitB" value="SubmitSubscribe" id="SubmitSubscribe">
                </div>
                <div class="footerLogo">
                    <img src="http://www.dev.actnow.org.uk/images/footer-logo.png " alt="logo">
                </div>
                <div class="clear"></div>
                <p class="copyright">© Act Now Training Ltd 2022</p>
            </div>
        </div>
        <div class="clear"></div>

    </footer>
    <div class="toTop">
        <p id="back-top" style="display: block;"><a href="#top"><span></span></a></p>
    </div>
    </div>
    <!-- Main Container : Ends -->
    <!-- ./wrapper -->
    <script type="text/javascript">var site_url = "http://www.dev.actnow.org.uk";</script>
    <script src="http://www.dev.actnow.org.uk/js/min.js"></script>
    <!--<script src="js/slick.min.js"></script>-->
    <script src="http://www.dev.actnow.org.uk/js/slick.js"></script>
    <script src="http://www.dev.actnow.org.uk/js/main.js"></script>
    <!-- <script type="text/javascript" src="http://www.dev.actnow.org.uk/js/search.js"></script> -->
    <script type="text/javascript">$("#MsgSubscribe").css({'display':'none'});
// console.log(sessionStorage.getItem('cartDropDown'));
function switchBanner(link){
  dataName = $(link).attr('data');
  $(link).addClass('active');
  if($(link).parent().siblings().children().hasClass('active')){
    $(link).parent().siblings().children().removeClass('active');
  }

  // console.log(dataName);
  // console.log('test');
  var slidesCount = $('.slick-track .sliderInfoWrapper').length;
  if(slidesCount > 1){
    var sliderName = $('.bannerText').closest('.bannerSlider');
    // console.log(sliderName);
    sliderName.each(function(){
      // console.log($(this).hasClass(dataName));
      if($(this).hasClass(dataName)){
        if(!$(this).hasClass('slick-cloned')){
          var sliderNumber = $(this).attr('class').replace('sliderInfoWrapper bannerSlider ','').replace(' slick-slide','');
          console.log(sliderNumber);
          if(sliderNumber.indexOf("slick-active")>=0){
            sliderNumber = sliderNumber.replace('slick-active','');
          }
          sliderNumber = sliderNumber.replace('slider-','');
          console.log(sliderNumber);
          var sliderWidth = $(this).width();
          var slidePixel = sliderNumber*sliderWidth;
          $(this).parent().css({'transform':"translate3d(-"+slidePixel+"px, 0px, 0px)"});
        }

        if(!$(this).addClass('slick-active')){
          $(this).addClass('slick-active');
        }
      }else{
        $(this).removeClass('slick-active');
        // console.log('opacity 0');
        // $(this).css('opacity','0');
        // $(this).css('z-index','800');
      }
    });
  }
}
function noenter(link){
  if(window.event && window.event.keyCode == 13){
    if($(link).val().length === 0){
      var subscribeTxt = "Enter an email to subscribe.";
      if($("#MsgSubscribe").hasClass("error-msg") == false){
        $("#MsgSubscribe").text(subscribeTxt).addClass('error-msg');
      }else{
        $("#MsgSubscribe").text(subscribeTxt).removeClass("success-msg").addClass('error-msg');
      }
    }else{
      var subscribeTxt ="Click '>' icon to subscribe.";
      if($("#MsgSubscribe").hasClass("error-msg") == false){
        $("#MsgSubscribe").text(subscribeTxt).addClass('error-msg');
      }else{
        $("#MsgSubscribe").text(subscribeTxt).removeClass("success-msg").addClass('error-msg');
      }
    }
    $('#MsgSubscribe').removeAttr('style');
    setTimeout(function(){
      if ($('#MsgSubscribe').length > 0) {
        $("#MsgSubscribe").text("").css({"display":"none"});
      }
    },3000);
    return false;
  }
}
$('#searchForm').submit(function(){
  var search = $.trim($('#search').val());
  if(search === ''){
    var search_error_message = "<span id='error-search' class='error-msg-red'>Kindly enter a keyword.</span>";
    $('#error-search').replaceWith(search_error_message);
    if($('#error-search').length>0){
      setTimeout(function(){
        $('#error-search').replaceWith("<span id='error-search' style='display:none;'></span>");
      },2000);
    }
    return false;
  }else if($('#search').val().length < 3){
    var search_error_message = "<span id='error-search' class='error-msg-red'>Please enter at least 3 characters.</span>";
    $('#error-search').replaceWith(search_error_message);
    if($('#error-search').length>0){
      setTimeout(function(){
        $('#error-search').replaceWith("<span id='error-search' style='display:none;'></span>");
      },2000);
    }
    return false;
  }
});
  $(document).on('ready', function() {
    $(".vertical-center-2").slick({
      dots: true,
      vertical: true,
      centerMode: true,
      slidesToShow: 2,
      slidesToScroll: 2
    });
    $(".lazy").slick({
      dots: true,
      lazyLoad: 'ondemand', // ondemand progressive anticipated
      infinite: true
    });
    /*$("#SubmitSubscribe").on('click',function () { $("#subscribeFrm").submit();});*/
    $("#SubmitSubscribe").on('click',function () {
      var subscribeEmail = $("#subscribeEmail").val();
      $('#SubmitSubscribe').attr('disabled',true);
      var token = $('input[name=_token]').val();
      $.ajax({
            url:"/subscribe",
            headers: {'X-CSRF-TOKEN': token},
            data:{"subscribeEmail":subscribeEmail},
            type: "POST",
            datatype: 'JSON',
            success:function(res){
              // console.log(res['msg']);
              $('#SubmitSubscribe').attr('disabled',false);
              if(res['status'] == 200){
                // $('#subscribeEmail').val('');
                $("#MsgSubscribe").text(res['msg']).removeClass("error-msg").addClass('success-msg').removeAttr("style");
                 setTimeout(function(){
                  if ($('#MsgSubscribe').length > 0) {
                    $("#MsgSubscribe").text("").css({'display':'none'});
                  }
                },3000);
              }else{
                $('#subscribeEmail').val('');
                $("#MsgSubscribe").text(res['msg']).removeClass("success-msg").addClass('error-msg').removeAttr("style");
                setTimeout(function(){
                    if ($('#MsgSubscribe').length > 0) {
                      $("#MsgSubscribe").text("").css({'display':'none'});
                    }
                  },5000);
              }

            }
        });
    });
  });
  $('.testimonials.responsive').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [

    ]
  });
  function openNav() {
    document.getElementById("mySidenav").style.width = "260px";
  }
  function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
  }
  // window.onscroll = function() {scrollFunction()};
  // function scrollFunction(){
  //   if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
  //     document.getElementById("myBtn").style.display = "block";
  //   } else {
  //     document.getElementById("myBtn").style.display = "none";
  //   }
  // }
  // When the user clicks on the button, scroll to the top of the document
  // function topFunction() {
  //   document.body.scrollTop = 0;
  //   document.documentElement.scrollTop = 0;
  // }
  // hide #back-top first
  $("#back-top").hide();

  // fade in #back-top
  $(function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('#back-top').fadeIn();
      } else {
        $('#back-top').fadeOut();
      }
    });

    // scroll body to 0px on click
    $('#back-top a').click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 800);
      return false;
    });
  });</script>

    <script type="text/javascript">var token = $('input[name=_token]').val();
var ID = 46;
	// console.log('if loop');
$(document).ready(function () {
	// console.log(sessionStorage);
	if(sessionStorage.getItem('cartDropDown') == 'true' && sessionStorage.getItem('itemBooked') == 'true'){
	  	$('.login-UL li.cart .cartDiv').slideDown("500ms");
	  	// console.log('if loop');
	  	sessionStorage.removeItem('itemBooked');
	  	sessionStorage.removeItem('cartDropDown');
		if (sessionStorage.scrollTop != "undefined") {
	    	$(window).scrollTop(sessionStorage.scrollTop);
		}
	}else{
		// console.log('else loop');
		if (sessionStorage.scrollTop != "undefined") {
	    	$(window).scrollTop(sessionStorage.scrollTop);
		}
	 //    $('html, body').animate({
	 //        scrollTop: $('.courseData').offset().top
		// }, 'slow');
	}

    // get filtered values
    var current_url = window.location.href;
    // if(getBetween(current_url,"ID=","&&")){
	    var previous_selected_categories = getBetween(current_url,"category=","&");
	    var previous_selected_location = getBetween(current_url,"location=","&");
	    var previous_selected_course_type = getBetween(current_url,"course-type=","&");
	    var previous_selected_from = getBetween(current_url,"from=","&");
	    var filtered_previous_from = previous_selected_from.replace('-','/').replace('-','/');
	    var previous_selected_to = getBetween(current_url,"to=","&");
	    var filtered_previous_to = previous_selected_to.replace('-','/').replace('-','/');
	    var previous_selected_sort_by = getBetween(current_url,"sort-by=","&");
	    // var previous_selected_sort_by_order = getBetween(current_url,"sort-by-order=","&");

	    if(previous_selected_categories != ''){
	    	var previous_category_id = previous_selected_categories.split(',');
	    	// console.log(previous_category_id);
	    	// var count = 0;
	    	$.each(previous_category_id, function (key, value) {
	    		// count++;
	    		if(value != ''){
	    			var allCheckboxID = new Array();
	    			var allCheckboxValue = new Array();
	    			$('input:checkbox.cat_filter').each(function(key,value){
	    				if(allCheckboxID.includes(value.value) == false){
	    					allCheckboxID.push(value.value);
	    					allCheckboxValue.push(value.id);
	    				}
	    			});
		    		// var element_value = $('[value$='+value+']').val();
		    		$.each(allCheckboxID,function(checkboxKey,checkboxValue){
			    		if(checkboxValue == value && parseInt(checkboxValue) != ID){
			    			// var name = $('[value$='+value+']').attr('id');
			    			var name = allCheckboxValue[checkboxKey];
			    			// console.log(name+' | '+value);
			    			// console.log($('#'+name+' .cat_filter'));
			    			// console.log($('.cat_filter[value$='+value+']'));
				    		// $('#'+name+'.cat_filter').prop("checked",true);
				    		$('.cat_filter[value$='+value+']').prop("checked",true);
					    	var previous_category_html = "<li onclick='delete_element(this)' id='cat_"+value+"' name='"+name+"'>"+name+"</li>";
					    	$("#filtered_list").append(previous_category_html);
					    }
					});
			    }
		    });
	    }
	    if(previous_selected_location != ''){
	    	var previous_location = previous_selected_location.split(',');
	    	// console.log(previous_category_id);
	    	// var count = 0;
	    	$.each(previous_location, function (key, value) {
	    		// count++;
	    		if(value != ''){
	    			var allLocationCheckboxID = new Array();
	    			var allLocationCheckboxValue = new Array();
	    			$('input:checkbox.location_filter').each(function(key,value){
	    				if(allLocationCheckboxID.includes(value.value) == false){
	    					allLocationCheckboxID.push(value.value);
	    					allLocationCheckboxValue.push(value.id);
	    				}
	    			});
		    		$.each(allLocationCheckboxID,function(checkboxKey,checkboxValue){
			    		if(checkboxValue == value){
			    			var name = allLocationCheckboxValue[checkboxKey];
				    		$('.location_filter[value$='+value+']').prop("checked",true);
					    	var previous_location_html = "<li onclick='delete_element(this)' class='selected_location_filter' id='location_"+value+"' name='"+value+"'>"+value+"</li>";
					    	$("#filtered_list").append(previous_location_html);
					    }
					});
			    }
		    });
	    }
	    if(previous_selected_course_type != ''){
	    	// console.log(previous_selected_duration);
	    	if(previous_selected_course_type == 'one_day_courses'){
				var name = "One Day Courses";
			}else if(previous_selected_course_type == 'certificate_courses'){
				var name = "Certificate Courses";
			}else if(previous_selected_course_type == "webinars"){
				var name = "Webinars";
			}
	    	var previous_course_type_html = "<li onclick='delete_element(this)' class='course_type_filtered_list' id='course_type_selected_filter' name='"+name+"'>"+name+"</li>";
	    	$("#filtered_list").append(previous_course_type_html);
	  		$('#course_type_filter').val(previous_selected_course_type);
	    }
	    if(filtered_previous_from != ''){
	    	$('#from_date').val(filtered_previous_from);
	    }
	    if(filtered_previous_to != ''){
	    	$('#to_date').val(filtered_previous_to);
	    }
	    if(previous_selected_sort_by != ''){
	    	$('#sort_by_filter').val(previous_selected_sort_by);
	    }
	  //   if(previous_selected_sort_by_order != ''){
	  //   	// if(previous_selected_sort_by_order != '' && previous_selected_sort_by != ''){
			// 	if(previous_selected_sort_by_order == "asc"){
			//     	$('#sort_by_filter :selected').attr('data-order','desc');
			//     }else{
			//     	$('#sort_by_filter :selected').attr('data-order','asc');
			//     }
			// // }
	  //   	// $('#sort_by_filter :selected').attr('data-order',previous_selected_sort_by_order);
	  //   }

});</script>
    <script src="//ajax.googleapis.com/ajax/libs/jqueryui/1.11.2/jquery-ui.min.js"></script>
    <!-- <script type="text/javascript" src="http://www.dev.actnow.org.uk/js/paginathing.min.js"></script> -->
    <!-- <script type="text/javascript" src="http://www.dev.actnow.org.uk/js/notifier.js"></script> -->
    <script type="text/javascript" src="http://www.dev.actnow.org.uk/js/paginathing.js"></script>
    <script src="http://www.dev.actnow.org.uk/plugins/datepicker/bootstrap-datepicker.js"></script>
    <script src="http://www.dev.actnow.org.uk/plugins/input-mask/jquery.inputmask.js"></script>
    <script src="http://www.dev.actnow.org.uk/plugins/input-mask/jquery.inputmask.extensions.js"></script>
    <!-- <script src="http://www.dev.actnow.org.uk/js/ul-pagination.js"></script> -->
    <script type="text/javascript">$('#filterUl').paginathing({
		perPage: 10,
		// limitPagination: 9,
		containerClass: 'panel-footer',
		insertAfter: '#emptySpan',
		pageNumbers: true
    });</script>
    <script type="text/javascript">// get sub-string a line between two strings
function getBetween(content,start,end){
    var r = content.split(start);
    if ((r[1])!=null){
        var r = r[1].split(end);
        return r[0];
    }
    return '';
}</script>
    <script type="text/javascript">// function Refresh(){
// 	window.location.reload(true);
// }
if($('#replace_div').hasClass('hide_sort')){
	$('.topSort').hide();
}else{
	if($('.topSort').css('display')=="none"){
		$('.topSort').show();
	}
}
$("#from_date").inputmask("99/99/9999");
$("#to_date").inputmask("99/99/9999");
$(function(){
	$('#from_date').datepicker({
		minDate:0,
		dateFormat:'mm/dd/yy',
		autoclose: true,
		changeMonth:true,
		changeYear:true,
		beforeShow: function (textbox, instance) {
            instance.dpDiv.css({
            	display:'none',
                marginTop: '-44px',
                position: 'absolute',
            });
        },
      // }
	})
});
$(function(){
	$('#to_date').datepicker({
		minDate:0,
		dateFormat:'mm/dd/yy',
	    autoclose: true,
	    changeMonth:true,
	    changeYear:true,
	    beforeShow: function (textbox, instance) {
            instance.dpDiv.css({
            	display:'none',
                marginTop: '-44px',
            });
        },
      // }
	})
});
// $('.ui-helper-clearfix').css("display","none");
// $('#ui-datepicker-div').css("display","none");
$(document).on("click", ".flip", function(){
	$(this).addClass("flipped");
	var c = $(this).find("input").val();
	var that = $(this);
	// console.log('test');
	if(c == "Book"){
		// console.log('testing');
		$(this).find("input").val("Added");
		$('.login-UL li.cart .cartDiv').slideDown("500ms");
		sessionStorage.setItem('cartDropDown', 'true');
		sessionStorage.setItem('itemBooked', 'true');
		sessionStorage.scrollTop = $(this).scrollTop();
		console.log(sessionStorage.scrollTop);
		// setTimeout(function(){
		// 	$("body, html").animate({
		// 		scrollTop: $('#top').offset().top
		// 	});
		// },500);

	}
	setTimeout(function(){
	    that.removeClass("flipped");
		that.find("input").val("Booked");
	}, 1000);
})

// $(document).on("click", ".flip-product", function(){
// 	$(this).addClass("flipped");
// 	var c = $(this).find("input").val();
// 	var that = $(this);
// 	if(c == "Book Product"){
// 		$(this).find("input").val("Added");
// 		$('.login-UL li.cart .cartDiv').slideDown("500ms");
// 		sessionStorage.setItem('cartDropDown', 'true');
// 		sessionStorage.setItem('itemBooked', 'true');
// 		console.log('testing');
// 		setTimeout(function(){
// 			$("body, html").animate({
// 				scrollTop: $('#top').offset().top
// 			});
// 		},500);
// 	}
// 	setTimeout(function()
// 	  {
// 	    that.removeClass("flipped");
// 		that.find("input").val("Added");

// 	  }, 1000);
// })

$(document).on("click", "#book", function(){
	$(this).addClass("flipped");
	var c = $(this).find("span").text();
	var that = $(this);
	if(c == "Book"){
		$(this).find("span").text("Added to Cart");
		$('.login-UL li.cart .cartDiv').slideDown("500ms");

		// if ($(this).length) {
		//   var position = $(this).offset().top;
		// }
		// var position = $('#headerCartId').offset().top;
		sessionStorage.setItem('cartDropDown', 'true');
		sessionStorage.setItem('itemBooked', 'true');
		sessionStorage.scrollTop = $(this).scrollTop();
		// setTimeout(function(){
		// 	$("body, html").animate({
		// 		scrollTop: $('#top').offset().top
		// 	});
		// },500);
	}
	setTimeout(function(){

		that.removeClass("flipped").removeClass('readB').addClass('adCart').removeAttr( "id" ).removeAttr( "onclick" ).attr('onclick', "javascript:window.location.href='/cart'; return false;");
		that.find("span").text("View Cart");
	}, 1000);
})

/*add to cart from index page course booking*/
function addToCart(val) {
	var venueId = val.value;
	var token = $('input[name=_token]').val();
	  $.ajax({
        url:"/add-to-cart",
        headers: {'X-CSRF-TOKEN': token},
        data:{"venueId":venueId},
        type: "POST",
        datatype: 'JSON',
        success:function(response){
          // console.log(response);
        	if(response['status'] == 404){
        		// console.log(response['message']);
        		$("#addToCartMessageIndex").text(response['message']);
        		setTimeout(function(){
        		    if ($('#addToCartMessageIndex').length > 0) {
        		      $("#addToCartMessageIndex").text("");
        		    }
        		},1000);
			}else{
        		// setTimeout(location.reload.bind(location), 1000);
        		// console.log(response);

        		if(response.cart_items.length > 0) {

        			$('#cartCount').text(response.cart_items.length);

        			var cart_total = 0;
        			var vat_total = 0;
        			var grand_total = 0;

        			$('#emptyCartMsg').hide();
        			$('.cartList').show();

        			// Update courses in cart header
        			$('.cartList > ul.courseList').empty();
        			var dom_cart = '';
        			for (var i = 0; i < response.cart_items.length; i++) {
        				var cart_item = response.cart_items[i];
        				if(cart_item.type == "Courses") {
	        				dom_cart += '<li id="header-row-cr-'+cart_item.id+'">';
	        				dom_cart += '<div class="leftName">';
	        				dom_cart += '<small>Course </small>';
	        				dom_cart += '<h5><a href="/course/'+cart_item.course_details.slug+'">'+cart_item.product_name+'</a></h5>';

	        				dom_cart += '<p><span>Date </span><strong>'+cart_item.course_venue.course_date.date+'</strong></p>';

	        				// Webinar, show timing?
	        				if(cart_item.course_location == "online") {

	        				}

	        				dom_cart += '<p><span>Location </span><strong>';
	        				dom_cart += cart_item.course_venue.city;
	        				dom_cart += '</strong></p>';
	        				dom_cart += '<p><span>Cost </span><strong>£'+cart_item.course_details.fee+'</strong></p>';
	        				dom_cart += '<p><span>Vat </span><strong><span class="priceSpan getVatClass-header" id="header-row-cr-'+cart_item.id+'">£'+cart_item.vat+'</span></strong></p>';
	        				dom_cart += '</div>';
	        				dom_cart += '</li>';

	        				cart_total = (parseFloat(cart_total) + parseFloat(cart_item.course_details.fee));
	        				vat_total = (parseFloat(vat_total) + parseFloat(cart_item.vat));
        				}

        				if(cart_item.type == "Products") {
	        				dom_cart += '<li id="header-row-pr-'+cart_item.id+'">';
	        				dom_cart += '<div class="leftName">';
	        				dom_cart += '<small>Product </small>';
	        				dom_cart += '<h5><a href="/product/'+cart_item.product_details.slug+'">'+cart_item.product_name+'</a></h5>';
	        				dom_cart += '<p><span>Date </span><strong>'+cart_item.product_details.created_at+'</strong></p>';
	        				dom_cart += '<p><span>Cost </span><strong>£'+cart_item.product_details.price+'</strong></p>';
	        				dom_cart += '<p><span>Vat </span><strong><span class="priceSpan getVatClass-header" id="header-row-pr-'+cart_item.id+'">£'+cart_item.vat+'</span></strong></p>';
	        				dom_cart += '</div>';
	        				dom_cart += '</li>';

	        				cart_total = (parseFloat(cart_total) + parseFloat(cart_item.product_details.price));
	        				vat_total = (parseFloat(vat_total) + parseFloat(cart_item.vat));

        				}

        			}

        			var grand_total = (parseFloat(cart_total) + parseFloat(vat_total));

        			$('.cartList > ul.courseList').append(dom_cart);
        			$('#cartTotal-header').html(cart_total);
        			$('#vatTotal-header').html(vat_total);
        			$('#finalTotal-header').html(grand_total);

        		}


        	}
        }
    });
}
/*add to cart from index page course booking*/
// function addProductToCart(val) {
// 	var productId = val.id;
// 	// var token = $('input[name=_token]').val();
// 	if(productId == 0){
// 		var failure_message = "<p id='disappear_text'>Max. quantity reached.</p>";
// 		$(val).parent().append(failure_message).fadeIn();
// 		setTimeout(function(){
// 			if ($('#disappear_text').length > 0) {
// 				$("#disappear_text").remove();
// 			}
// 		},1500);
// 	}else{
// 		$.ajax({
// 		    url:"/add-to-cart",
// 		    headers: {'X-CSRF-TOKEN': token},
// 		    data:{"productId":productId},
// 		    type: "POST",
// 		    datatype: 'JSON',
// 		    success:function(response){
// 		    	if(response['status'] == 404){
// 		    		var failure_message = "<div class='error-msg-red' id='disappear_text'>"+response['message']+"</div>";
// 	          		$(val).siblings().append(failure_message).fadeIn();
// 					setTimeout(function(){
// 						if ($('#disappear_text').length > 0) {
// 							$("#disappear_text").remove();
// 						}
// 					},1500);
// 		    	}else{
// 		    		ProcessAfterSuccess();
// 		    	}
// 		    }
// 		});
// 	}
// }
function buildUrl(){
	var condition_array = confirm_conditions();
	// console.log(condition_array);
	if((condition_array['category_filter']).length != 0){
		var removing_index = condition_array['category_filter'].indexOf(ID);
		// console.log(condition_array['category_filter'],removing_index);
		var category_slug = "category="+condition_array['category_filter'];
	}else{
		var category_slug = "";
	}
	if((condition_array['location_filter']).length != 0){
		var location_slug = "location="+condition_array['location_filter'];
	}else{
		var location_slug = "";
	}
	if(condition_array['course_type'] != undefined){
		var courseType_slug = "course-type="+condition_array['course_type'];
	}else{
		var courseType_slug = "";
	}
	// console.log(courseType_slug);
	if(condition_array['from'] !='' && condition_array['from'] != null){
		var replace_from = condition_array['from'].replace('/','-').replace('/','-');
		var from_slug = "from="+replace_from;
	}else{
		var from_slug = "";
	}
	if(condition_array['to'] != '' && condition_array['to'] != null){
		var replace_to = condition_array['to'].replace('/','-').replace('/','-');
		var to_slug = "to="+replace_to;
	}else{
		var to_slug = "";
	}
	if(condition_array['sort_by'] != null){
		var sortBy_slug = "sort-by="+condition_array['sort_by'];
	}else{
		var sortBy_slug = "";
	}
	// if(condition_array['sort_by'] != null){
	// 	// if(condition_array['order'] == "desc"){
	// 	// 	var order = 'asc';
	// 	// }else{
	// 	// 	var order = 'desc';
	// 	// }
	// 	// var sortByOrder_slug = "sort-by-order="+order;
	// 	var sortByOrder_slug = "sort-by-order="+condition_array['order'];
	// }else{
	// 	var sortByOrder_slug = "";
	// }
	// console.log(category_slug);
	// if( category_slug != '' || courseType_slug!='' || location_slug != '' || from_slug != '' || to_slug != '' || sortBy_slug != '' || sortByOrder_slug != ''){
	if( category_slug != '' || courseType_slug!='' || location_slug != '' || from_slug != '' || to_slug != '' || sortBy_slug != '' ){
		var conditional_amp_one = category_slug != '' ? "&":"";
		var conditional_amp_three = location_slug != '' ? "&":"";
		var conditional_amp_four = to_slug !='' ? "&":"";
		var conditional_amp_five = sortBy_slug != '' ? "&":"";
		// var conditional_amp_six = sortByOrder_slug != '' ? "&":"";
		var conditional_amp_seven = courseType_slug != '' ? "&":"";
		var filter = "/"+category_slug+conditional_amp_one+location_slug+conditional_amp_three+from_slug+conditional_amp_four+to_slug+conditional_amp_five+sortBy_slug+conditional_amp_seven+courseType_slug;
	}else{
		var filter = "";
	}
	// console.log(filter);
	if(filter.indexOf('/&')>=0){
		var filter = filter.replace('/&','/');
	}
	var filter = filter.replace(new RegExp('&$'),'');
	var filter = filter.replace(new RegExp('&&'),'&');

	var url = window.location.href;
	if(url.indexOf('/category=')>=0){
		url = url.substring(0,url.indexOf('/category='));
	}
	else if(url.indexOf('/location=')>=0){
		url = url.substring(0,url.indexOf('/location='));
	}
	else if(url.indexOf('/from=')>=0){
		url = url.substring(0,url.indexOf('/from='));
	}else if(url.indexOf('/to=')>=0){
		url = url.substring(0,url.indexOf('/to='));
	}
	else if(url.indexOf('/sort-by=')>=0){
		url = url.substring(0,url.indexOf('/sort-by='));
	}
	else if(url.indexOf('/course-type=')>=0){
		url = url.substring(0,url.indexOf('/course-type='));
	}
	var url = url+filter;
	return url;
}
function ProcessAfterSuccess(){
	var url = buildUrl();
	// console.log('url',url);
	setTimeout(window.location.href=url,5000);
}
function appendUrl(){
	var url = buildUrl();
	window.history.pushState('',"", url)
}
//category filter scripts
function delete_element(link){
	// console.log(link);
	$(link).remove();
	var element_name = $(link).attr('name');
	// console.log(element_name);
	if($(link).hasClass('filtered_sort_by')){
		var element_id = $(link).prop('id');
		if(element_id.includes('sort_by_filter') == true){
			$('#sort_by_filter option[value=""]').prop('selected',true);
		}
	}else if($(link).hasClass('course_type_filtered_list')){
		var element_id = $(link).prop('id').replace('_selected','');
		$('#'+element_id+' option[value=""]').prop('selected',true);
	}else if($(link).hasClass('selected_location_filter')){
		var element_id = $(link).prop('id');
		// console.log('#'+element_id);
		$('#'+element_id).prop('checked',false);
	}else{
		var checkbox_element = document.getElementById(element_name);
		// console.log(checkbox_element.checked);
		checkbox_element.checked = false;
	}
	var condition_array = confirm_conditions();
	$.ajax({
        url:"/cat-filter",
        headers: {'X-CSRF-TOKEN': token},
        data:{"ID":ID,"category_filter":condition_array['category_filter'],"location_filter":condition_array['location_filter'],"from":condition_array['from'],"to":condition_array['to'],'sort_by':condition_array['sort_by'],'course_type':condition_array['course_type'],'order':condition_array['order']},
        type: "POST",
        datatype: 'JSON',
        beforeSend: function(){
        	$('.loadingGif').show();
        },
        success:function(response){
        	$('#replace_div').replaceWith(response);
        	// console.log('Successfully filtered');
        },
        complete: function (response) {
			$('#filterUl').paginathing({
				perPage: 10,
				// limitPagination: 9,
				containerClass: 'panel-footer',
				insertAfter: '#emptySpan',
				pageNumbers: true
		    });
		    if($('#replace_div').hasClass('hide_sort')){
				$('.topSort').hide();
			}else{
				if($('.topSort').css('display')=="none"){
					// console.log('test');
					$('.topSort').show();
				}
			}
		    $('.loadingGif').hide();
		    appendUrl();
	    }
    });
}
function confirm_conditions(){
	// category conditions
	var category_conditions =[];
	var location_conditions =[];
	$.each($(".cat_filter:checkbox:checked"), function(k,v){
		// console.log(v.value,parseInt(v.value));
        category_conditions.push(v.value);
  //       if(category_conditions.includes(ID) == false && parseInt(v.value) != ID){
		// 	category_conditions.push(ID);
		// }
    });
    // console.log($(".location_filter:checkbox:checked"));
    $.each($(".location_filter:checkbox:checked"), function(k,v){
		// if(location_conditions.includes(ID) == false){
		// 	location_conditions.push(ID);
		// }
		// console.log(v);
        location_conditions.push(v.value);
    });
    // console.log(category_conditions);
    // price conditions
    // var price_condition = $('.price_filter:radio:checked').val();
    //date conditions
    var from_date = $('#from_date').val();
    var to_date = $('#to_date').val();
    // duration filter
    // var duration_condition = $('.duration_filter:radio:checked').val();
    // booking filter
    // var booking_condition = $('#availability').val();
    // sorting filter
    var sorted = $('#sort_by_filter').val();
    // var order = $('#sort_by_filter :selected').attr('data-order');
    // console.log(order);
    var course_type = $('#course_type_filter').val();
    // console.log(category_conditions);
    // console.log(course_type);
    data_set = {'category_filter':category_conditions,"location_filter":location_conditions,'from':from_date,'to':to_date,"sort_by":sorted,"course_type":course_type};
    // console.log(data_set);
    return data_set;
}

$('.cat_filter').on('click',function(){
	var checkbox_value = $(this).val();
	var checkboxName = $(this).attr('id');
	// checking all filter conditions
	// if($(this).hasClass('lvl_one_category')){
	// 	if($(this).prop("checked") == true){
	// 		$(this).parent().next().find('li').find('input[type=checkbox]').prop("checked",true);
	// 		var child_array_value = new Array();
	// 		var child_array_name = new Array();
	// 		$(this).parent().next().find('li').find('input[type=checkbox]').each(function(key,value){
	// 			// console.log(value.value);
	// 			if(child_array_value.includes(value.value) == false){
	// 				child_array_value.push(value.value);
	// 			}
	// 			if(child_array_name.includes(value.id) == false){
	// 				child_array_name.push(value.id);
	// 			}
	// 		});
	// 		// console.log('if loop',child_array_name,child_array_value);
	// 	}else{
	// 		$(this).parent().next().find('li').find('input[type=checkbox]').prop("checked",false);
	// 		var child_array_value = new Array();
	// 		var child_array_name = new Array();
	// 		$(this).parent().next().find('li').find('input[type=checkbox]').each(function(key,value){
	// 			// console.log(value.value);
	// 			if($('#cat_'+$(this).val()).length != 0){
	// 				delete_element($('#cat_'+$(this).val()));
	// 			}
	// 			if(child_array_value.includes(value.value) == true){
	// 				// child_array_value.push(value.value);
	// 				child_array_value.splice(key,1);
	// 				// delete_element(this);
	// 			}
	// 			if(child_array_name.includes(value.id) == true){
	// 				// child_array_name.push(value.id);
	// 				child_array_name.splice(key,1);
	// 			}

	// 		});
	// 		// console.log('else loop',child_array_name,child_array_value);
	// 	}
	// }
	// else{
		// console.log('false');
	// }
	var condition_array = confirm_conditions();
	// console.log(condition_array,'test');
	if($(this).prop("checked")){
		var category_html = "<li onclick='delete_element(this)' id='cat_"+checkbox_value+"' name='"+checkboxName+"'>"+checkboxName+"</li>";
		$.ajax({
	        url:"/cat-filter",
	        headers: {'X-CSRF-TOKEN': token},
	        data:{"ID":ID,"category_filter":condition_array['category_filter'],"location_filter":condition_array["location_filter"],"from":condition_array['from'],"to":condition_array['to'],'sort_by':condition_array['sort_by'],'course_type':condition_array['course_type']},
	        type: "POST",
	        datatype: 'JSON',
	        beforeSend: function(){
	        	$('.loadingGif').show();
	        },
	        success:function(response){
	        	// console.log(response);
	        	$('#replace_div').replaceWith(response);
	        	$("#filtered_list").append(category_html);
	        	// for(var key in child_array_value){
	        	// 	var child_category_html = "<li onclick='delete_element(this)' id='cat_"+child_array_value[key]+"' name='"+child_array_name[key]+"'>"+child_array_name[key]+"</li>";
	        	// 	// console.log(value);
	        	// 	// console.log(child_category_html);
	        	// 	if($('#cat_'+child_array_value[key]).length <= 0){
	        	// 		$("#filtered_list").append(child_category_html);
	        	// 	}
	        	// };
	        	// console.log('Successfully filtered');
	        },
	        complete: function (response) {
		     //  	var filterPager = new pagination('filterUl', 'filter-li', 8);
			    // filterPager.showPagination('filterPager', 'filterPaginationContainer');
			    // filterPager.showPage(1);
			 	if(document.getElementById('filterUl')){
				 //    $('#filterUl').paginate({
					// 	perPage: 8,
					// 	paginatePosition: ['top','bottom'],
					// 	useHashLocation:false,
					// })
					if($('#filterUl li').length != 0){
						$('#filterUl').paginathing({
							perPage: 10,
							// limitPagination: 9,
							containerClass: 'panel-footer',
							insertAfter: '#emptySpan',
							pageNumbers: true
					    });
					}else{
						var replace_content = "<div id='replace_div' class='hide_sort'><strong>No courses available</strong><div class='clear'></div></div>";
						$("#replace_div").replaceWith(replace_content);
					}
				}
				if($('#replace_div').hasClass('hide_sort')){
					$('.topSort').hide();
				}else{
					// console.log('cehckbxo test');
					if($('.topSort').css('display')=="none"){
						$('.topSort').show();
					}
				}
				$('.loadingGif').hide();
				appendUrl();
		    }
	    });

	}else{
		var element = document.getElementsByName(checkboxName);
		$.ajax({
	        url:"/cat-filter",
	        headers: {'X-CSRF-TOKEN': token},
	        data:{"ID":ID,"category_filter":condition_array['category_filter'],"location_filter":condition_array["location_filter"],"from":condition_array['from'],"to":condition_array['to'],'sort_by':condition_array['sort_by'],'course_type':condition_array['course_type']},
	        type: "POST",
	        datatype: 'JSON',
	        beforeSend: function(){
	        	$('.loadingGif').show();
	        },
	        success:function(response){
	        	// console.log(response);
	        	$('#replace_div').replaceWith(response);
	        	$(element).remove();
	        	// console.log('Successfully filtered');
	        },
	        complete: function (response) {
		     //  	var filterPager = new pagination('filterUl', 'filter-li', 8);
			    // filterPager.showPagination('filterPager', 'filterPaginationContainer');
			    // filterPager.showPage(1);
			    if(document.getElementById('filterUl')){
				 //    $('#filterUl').paginate({
					// 	perPage: 8,
					// 	paginatePosition: ['top','bottom'],
					// 	useHashLocation:false,
					// })
					if($('#filterUl li').length != 0){
						$('#filterUl').paginathing({
							perPage: 10,
							// limitPagination: 9,
							containerClass: 'panel-footer',
							insertAfter: '#emptySpan',
							pageNumbers: true
					    });
					}else{
						var replace_content = "<div id='replace_div' class='hide_sort'><strong>No courses available</strong><div class='clear'></div></div>";
						$("#replace_div").replaceWith(replace_content);
					}
				}
				if($('#replace_div').hasClass('hide_sort')){
					$('.topSort').hide();
				}else{
					// console.log('cehckbxo test');
					if($('.topSort').css('display')=="none"){
						// console.log('cehckbxo test');
						$('.topSort').show();
					}
				}
				$('.loadingGif').hide();
				appendUrl();
		    }
	    });
	}
});
$('.location_filter').on('click',function(){
	var checkbox_value = $(this).val();
	var checkboxName = $(this).attr('id').replace('location_','');
	// checking all filter conditions
	// if($(this).hasClass('lvl_one_category')){
	// 	if($(this).prop("checked") == true){
	// 		$(this).parent().next().find('li').find('input[type=checkbox]').prop("checked",true);
	// 		var child_array_value = new Array();
	// 		var child_array_name = new Array();
	// 		$(this).parent().next().find('li').find('input[type=checkbox]').each(function(key,value){
	// 			// console.log(value.value);
	// 			if(child_array_value.includes(value.value) == false){
	// 				child_array_value.push(value.value);
	// 			}
	// 			if(child_array_name.includes(value.id) == false){
	// 				child_array_name.push(value.id);
	// 			}
	// 		});
	// 		console.log('if loop',child_array_name,child_array_value);
	// 	}else{
	// 		$(this).parent().next().find('li').find('input[type=checkbox]').prop("checked",false);
	// 		var child_array_value = new Array();
	// 		var child_array_name = new Array();
	// 		$(this).parent().next().find('li').find('input[type=checkbox]').each(function(key,value){
	// 			// console.log(value.value);
	// 			if($('#cat_'+$(this).val()).length != 0){
	// 				delete_element($('#cat_'+$(this).val()));
	// 			}
	// 			if(child_array_value.includes(value.value) == true){
	// 				// child_array_value.push(value.value);
	// 				child_array_value.splice(key,1);
	// 				// delete_element(this);
	// 			}
	// 			if(child_array_name.includes(value.id) == true){
	// 				// child_array_name.push(value.id);
	// 				child_array_name.splice(key,1);
	// 			}

	// 		});
	// 		console.log('else loop',child_array_name,child_array_value);
	// 	}
	// }
	// else{
		// console.log('false');
	// }
	var condition_array = confirm_conditions();

	if($(this).prop("checked")){
		// console.log(condition_array);
		var course_html = "<li onclick='delete_element(this)' class='selected_location_filter' id='location_"+checkbox_value+"' name='"+checkboxName+"'>"+checkboxName+"</li>";
		$.ajax({
	        url:"/cat-filter",
	        headers: {'X-CSRF-TOKEN': token},
	        data:{"ID":ID,"category_filter":condition_array['category_filter'],"location_filter":condition_array["location_filter"],"from":condition_array['from'],"to":condition_array['to'],'sort_by':condition_array['sort_by'],'course_type':condition_array['course_type']},
	        type: "POST",
	        datatype: 'JSON',
	        beforeSend: function(){
	        	$('.loadingGif').show();
	        },
	        success:function(response){
	        	// console.log(response);
	        	$('#replace_div').replaceWith(response);
	        	$("#filtered_list").append(course_html);
	        	// for(var key in child_array_value){
	        	// 	var child_category_html = "<li onclick='delete_element(this)' id='cat_"+child_array_value[key]+"' name='"+child_array_name[key]+"'>"+child_array_name[key]+"</li>";
	        	// 	// console.log(value);
	        	// 	// console.log(child_category_html);
	        	// 	if($('#cat_'+child_array_value[key]).length <= 0){
	        	// 		$("#filtered_list").append(child_category_html);
	        	// 	}
	        	// };
	        	// console.log('Successfully filtered');
	        },
	        complete: function (response) {
		     //  	var filterPager = new pagination('filterUl', 'filter-li', 8);
			    // filterPager.showPagination('filterPager', 'filterPaginationContainer');
			    // filterPager.showPage(1);
			 	if(document.getElementById('filterUl')){
				 //    $('#filterUl').paginate({
					// 	perPage: 8,
					// 	paginatePosition: ['top','bottom'],
					// 	useHashLocation:false,
					// })
					if($('#filterUl li').length != 0){
						$('#filterUl').paginathing({
							perPage: 10,
							// limitPagination: 9,
							containerClass: 'panel-footer',
							insertAfter: '#emptySpan',
							pageNumbers: true
					    });
					}else{
						var replace_content = "<div id='replace_div' class='hide_sort'><strong>No courses available</strong><div class='clear'></div></div>";
						$("#replace_div").replaceWith(replace_content);
					}
				}
				if($('#replace_div').hasClass('hide_sort')){
					$('.topSort').hide();
				}else{
					// console.log('cehckbxo test');
					if($('.topSort').css('display')=="none"){
						$('.topSort').show();
					}
				}
				$('.loadingGif').hide();
				appendUrl();
		    }
	    });

	}else{
		var element = document.getElementsByName(checkboxName);
		$.ajax({
	        url:"/cat-filter",
	        headers: {'X-CSRF-TOKEN': token},
	        data:{"ID":ID,"category_filter":condition_array['category_filter'],"location_filter":condition_array["location_filter"],"from":condition_array['from'],"to":condition_array['to'],'sort_by':condition_array['sort_by'],'course_type':condition_array['course_type']},
	        type: "POST",
	        datatype: 'JSON',
	        beforeSend: function(){
	        	$('.loadingGif').show();
	        },
	        success:function(response){
	        	// console.log(response);
	        	$('#replace_div').replaceWith(response);
	        	$(element).remove();
	        	// console.log('Successfully filtered');
	        },
	        complete: function (response) {
		     //  	var filterPager = new pagination('filterUl', 'filter-li', 8);
			    // filterPager.showPagination('filterPager', 'filterPaginationContainer');
			    // filterPager.showPage(1);
			    if(document.getElementById('filterUl')){
				 //    $('#filterUl').paginate({
					// 	perPage: 8,
					// 	paginatePosition: ['top','bottom'],
					// 	useHashLocation:false,
					// })
					if($('#filterUl li').length != 0){
						$('#filterUl').paginathing({
							perPage: 10,
							// limitPagination: 9,
							containerClass: 'panel-footer',
							insertAfter: '#emptySpan',
							pageNumbers: true
					    });
					}else{
						var replace_content = "<div id='replace_div' class='hide_sort'><strong>No courses available</strong><div class='clear'></div></div>";
						$("#replace_div").replaceWith(replace_content);
					}
				}
				if($('#replace_div').hasClass('hide_sort')){
					$('.topSort').hide();
				}else{
					// console.log('cehckbxo test');
					if($('.topSort').css('display')=="none"){
						// console.log('cehckbxo test');
						$('.topSort').show();
					}
				}
				$('.loadingGif').hide();
				appendUrl();
		    }
	    });
	}
});
$('#sort_by_filter,#from_date,#to_date,#course_type_filter').on('change',function(){
	// checking all filter conditions
	// var current_date = new Date();
	// current_date = current_date.toString("mm/dd/yy");
	// if($('#from_date').val().length>0){
	// 	var current_date = new Date();
	// 	var month = ("0" + (current_date.getMonth() + 1)).slice(-2);
	// 	var date = ("0" + (current_date.getDate())).slice(-2);
	// 	var year = current_date.getFullYear();
	// 	new_date = month+'/'+date+'/'+year;
	// 	// console.log(typeof month, month,typeof date, date,);
	// 	if($('#from_date').val().length>0){
	// 		if($('#from_date').val() < new_date){
	// 			$('#from_date').val(new_date);
	// 		}
	// 	}
	// }
	// console.log($('#from_date').val().length,$('#to_date').val().length);
	// if($('#to_date').val().length>0){
	// 	var current_date = new Date();
	// 	var month = ("0" + (current_date.getMonth() + 1)).slice(-2);
	// 	var date = ("0" + (current_date.getDate())).slice(-2);
	// 	var year = current_date.getFullYear();
	// 	new_date = month+'/'+date+'/'+year;
	// 	// console.log(typeof new_date,typeof $('#to_date').val(),parseInt($('#to_date').val()) parseInt(new_date));
	// 	if($('#to_date').val().length>0){
	// 		if(parseInt($('#to_date').val()) < parseInt(new_date)){
	// 			$('#to_date').val(new_date);
	// 		}
	// 	}
	// }
	// console.log($(this).attr('id'));

	if($(this).attr('id')=='course_type_filter'){
		$('#filtered_list > li').each(function(){
    		if($(this).hasClass('course_type_filtered_list')){
    			$(this).remove();
    		}
    	});
		var selectBox_value = $(this).val();
		// var selectBoxName = $(this).attr('id');
		var selectBoxName = $( "#course_type_filter option:selected" ).text();
		// console.log(selectBox_value,selectBoxName);

		if(selectBox_value != "") {
			var course_type_html = "<li onclick='delete_element(this)' class='course_type_filtered_list' id='course_type_selected_filter' name='"+selectBoxName+"'>"+selectBoxName+"</li>";
		}
		else {
			var course_type_html = "";
		}

		// console.log(course_type_html);
	}else{
		var course_type_html = "";
	}
	var condition_array = confirm_conditions();
	// console.log(condition_array);
	$.ajax({
        url:"/cat-filter",
        headers: {'X-CSRF-TOKEN': token},
        data:{"ID":ID,"category_filter":condition_array['category_filter'],"from":condition_array['from'],"to":condition_array['to'],'sort_by':condition_array['sort_by'],'course_type':condition_array['course_type']},
        type: "POST",
        datatype: 'JSON',
        beforeSend: function(){
        	$('.loadingGif').show();
        },
        success:function(response){
        	// console.log(response);
        	$('#replace_div').replaceWith(response);
        	// if($(this).attr('id')=='course_type_filter'){
        	$("#filtered_list").append(course_type_html);
   //      	if(condition_array['sort_by'] != null && condition_array['order'] != null){
			// 	if($('#sort_by_filter :selected').attr('data-order') == "asc"){
			//     	$('#sort_by_filter :selected').attr('data-order','desc');
			//     }else{
			//     	$('#sort_by_filter :selected').attr('data-order','asc');
			//     }
			// }
        	// }
        	// console.log('Successfully filtered');
        },
        complete: function (response) {
	     //  	var filterPager = new pagination('filterUl', 'filter-li', 8);
		    // filterPager.showPagination('filterPager', 'filterPaginationContainer');
		    // filterPager.showPage(1);
		    if(document.getElementById('filterUl')){
			 //    $('#filterUl').paginate({
				// 	perPage: 8,
				// 	paginatePosition: ['top','bottom'],
				// 	useHashLocation:false,
				// })
				if($('#filterUl li').length != 0){
					$('#filterUl').paginathing({
						perPage: 10,
						// limitPagination: 9,
						containerClass: 'panel-footer',
						insertAfter: '#emptySpan',
						pageNumbers: true
				    });
				}else{
					var replace_content = "<div id='replace_div' class='hide_sort'><strong>No courses available</strong><div class='clear'></div></div>";
					$("#replace_div").replaceWith(replace_content);
				}
			}
			if($('#replace_div').hasClass('hide_sort')){
				$('.topSort').hide();
			}else{
				if($('.topSort').css('display')=="none"){
					$('.topSort').show();
				}
			}
			$('.loadingGif').hide();
			appendUrl();
	    }
    });
});</script>
    <script src="//ajax.googleapis.com/ajax/libs/jqueryui/1.11.2/jquery-ui.min.js"></script>
    <script type="text/javascript" src="http://www.dev.actnow.org.uk/js/notifier.js"></script>


    <script type="text/javascript">$(document).ready(function(){
		$('body').on('click', '.btn-number', function(e) {
		         e.preventDefault();
		         $("#proceedToCheckout").hide();
		         fieldName = $(this).attr('data-field');
		         type      = $(this).attr('data-type');
		         var input = fieldName?$("input[name='"+fieldName+"']"):$(this).parent().find('input.input-number');

		         var currentVal = parseInt(input.val());
		         if (!isNaN(currentVal)) {
		             if(type == 'minus') {

		                 if(currentVal > parseInt(input.attr('min')) && (!isNaN(currentVal)) ) {
		                     input.val(currentVal - 1).change();

		                     $("#msg-"+fieldName).text("");
		                 }else{

		 					$("#msg-"+fieldName).text('Sorry, Min quantity required is '+ input.attr('min'));

		 				}
		                 if(parseInt(input.val()) == input.attr('min')) {
		                    // $(this).attr('disabled', true);
		                 }
		             } else if(type == 'plus') {

		                 if(currentVal < parseInt(input.attr('max')) && (!isNaN(currentVal))) {
		                     input.val(currentVal + 1).change();

		                     $("#msg-"+fieldName).text("");
		                 }else{

		                 	$("#msg-"+fieldName).text('Sorry, Max Available quantity is '+input.attr('max'));

		 				}
		                 if(parseInt(input.val()) == input.attr('max')) {
		                    // $(this).attr('disabled', true);

		                 }
		             }
		        } else {
		             input.val(0);
		        }
		         // changeTotalWithQuantity(fieldName);
		});

		/*prevent letters typing */
		$('body').on('keydown', '.input-number', function(e) {
		        // Allow: backspace, delete, tab, escape, enter and .
		        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
		            // Allow: Ctrl+A
		            (e.keyCode == 65 && e.ctrlKey === true) ||
		            // Allow: home, end, left, right
		            (e.keyCode >= 35 && e.keyCode <= 39)) {
		            // let it happen, don't do anything
		            return;
		        }
		        // Ensure that it is a number and stop the keypress
		        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
		            e.preventDefault();
		        }
		});

		$('body').on('change', '.input-number', function(e) {
		 	 $("#proceedToCheckout").hide();
		     minValue =  parseInt($(this).attr('min'));
		     maxValue =  parseInt($(this).attr('max'));
		     valueCurrent = parseInt($(this).val());
		     name = $(this).attr('name');
		     if(valueCurrent > minValue) {
		         $(".btn-number[data-type='minus']").removeAttr('disabled')
		      	 $("#msg-"+name).text("");
		     } else {

		     	$(this).val(minValue);
		     	$("#msg-"+name).text('Sorry, Min quantity required is '+minValue);

		     }
		     if(valueCurrent < maxValue) {
		         $(".btn-number[data-type='plus']").removeAttr('disabled')
		       $("#msg-"+name).text("");
		     } else {

		     	$(this).val(maxValue);
		     	$("#msg-"+name).text('Sorry, Max Available quantity is '+maxValue);


		     }
		      changeTotalWithQuantity(name);

		});

});
		function changeTotalWithQuantity(name) {
			// alert('check');
			var token = $('input[name=_token]').val();
			/* var qty = $('input[name='+name+']').val();
			  var min = $('input[name='+name+']').attr('min');
			  var max = $('input[name='+name+']').attr('max');*/
			  var qty = parseInt($('input[name=' + name + ']').val());
			  var min = parseInt($('input[name=' + name + ']').attr('min'));
			  var max = parseInt($('input[name=' + name + ']').attr('max'));
			  if(qty < min){
			  	qty = min;
			  }else if(qty > max){
			  	qty = max;
			  }
			 if(qty > 0 ){
			 			 	$.ajax({
			 		        url:"/change-total-vat",
			 		        headers: {'X-CSRF-TOKEN': token},
			 		        data:{"name":name,'qty':qty},
			 		        type: "POST",
			 		        datatype: 'JSON',
			 		        success:function(data){
			 		        	console.log(data);
			 		          	var rowId = data['rowId'];
			 		          	$('#header-row-'+rowId+ ' #header-total-'+rowId).text("£"+data['newTotal']); //
	    	         			$('#header-row-'+rowId+ ' #header-vat-'+rowId).text("£"+data['newVat']);
	    	         			updateCartHeader('noMsg');
			 		        }
			 		    	});

			 }else{
			 	 var arr = name.split('-');
			 	 remove(arr[1]+"-"+arr[2]);
			 }


		}

	 	function updateCartHeader(val) {
	 		console.log("updateCartHeader");
	 		$(".qty-msg").hide();
			var total = 0;
			var final = 0;
			  $(".getTotalClass-header").each(function() {
			    total += parseFloat($(this).text().replace(/\u00A3/g, ''));
			  });
			var vat = 0;
			  $(".getVatClass-header").each(function() {
			    vat += parseFloat($(this).text().replace(/\u00A3/g, ''));
			  });


			final = vat + total;
			 $('#cartTotal-header').text(total);
			 $('#vatTotal-header').text(vat);
			 $('#finalTotal-header').text(final);
			 if(val != "noMsg") {
			 	$("#hcMessage").text("Cart Updated successfully.").removeClass("error-msg-red").addClass("success-msg").removeAttr('style');
				setTimeout(function(){
				    if ($('#hcMessage').length > 0) {
				       $("#hcMessage").text("").css({"display":"none"});
				    }
				},3000);
			 }

		}


	function remove(val) {
	 	var row_id = val;
	 	$val = confirm("Would you like to remove this from cart? Please note respective delegate details will also be removed.");
	 	if($val){
	 		 // $('#row-'+row_id).remove();
	     	var token = $('input[name=_token]').val();
	     	$.ajax({
	            url:"/guest/remove-cart",
	            headers: {'X-CSRF-TOKEN': token},
	            data:{"row_id":row_id},
	            type: "POST",
	            datatype: 'JSON',
	            success:function(response){
	             	location.reload();
	             }
	         });
	 	}else{
	       return false;
	    }
	}

		function removeCartHeader(val) {
		 	var row_id = val;
		 	var removable = $('#header-row-'+row_id).find('h5 a').text();
		 	$val = confirm("Really want to remove "+ removable +" from cart ?");
		 	if($val){
		     	var token = $('input[name=_token]').val();
		     	  $.ajax({
		             url:"/remove-cart",
		             headers: {'X-CSRF-TOKEN': token},
		             data:{"row_id":row_id},
		             type: "POST",
		             datatype: 'JSON',
		             success:function(response){
		               console.log(response);
		                var currSubtotal = $('#header-row-'+row_id).find('.cost').text();
		               subtotal = $('#cartTotal-header').text();
		               newSubtotal = parseInt(subtotal) - parseInt(currSubtotal);
		               $('#cartTotal-header').text(newSubtotal);
		                var currVat = $('#header-row-'+row_id).find('.priceSpan').text();
		               totalVat = $('#vatTotal-header').text();
		                newvat = parseInt(totalVat) - parseInt(currVat);
		                if(isNaN(newvat)){
		                	newvat = 0;
		                }
		                 $('#vatTotal-header').text(newvat);
		                 $('#header-row-'+row_id).remove();
		                 $('#cartCount').text(response['cartCount']);
		                  $("#hcMessage").text(response['message']).removeClass("error-msg-red").addClass("success-msg").removeAttr('style');
		                 setTimeout(function(){
		                         	     if ($('#hcMessage').length > 0) {
		                         	       $("#hcMessage").text("").css({"display":"none"});
		                         	     }
		                         	 },3000);
		                /* var scroll_position = $(window).scrollTop();
	          			(function($){
	          				 $.notifier({
	          				 'title':'Cart Details',
	          				 'text':response['message'],
	          				 "type": "success",
	          				  'scrollPosition':scroll_position,
	          				 'positionY':'top',
	          				'positionX':'left',
	          				'delay':10000,
	          				"animationIn" : 'shake',
	          				"animationIn_duration": 'slow',
	          				"animationOut" : 'drop',
	          				"animationOut_duration" : 'slow',
	          			 }); })(jQuery);*/
		                 if(response['cartCount'] == 0){
		                 	window.location.href = "/cart";
		                 }
		             }
		         });
		 	}else{
		       return false;
		    }
		}

        function showHcMsg(msg) {
        	 $("#hcMessage").text(msg).removeClass("success-msg").addClass("error-msg-red").removeAttr('style');
        	 setTimeout(function(){
        	     if ($('#hcMessage').length > 0) {
        	       $("#hcMessage").text("").css({"display":"none"});
        	     }
        	 },3000);
     		  /*var scroll_position = $(window).scrollTop();
    			(function($){
    				 $.notifier({
    				 'title':'Cart Details',
    				 'text':msg,
    				 "type": "error",
    				  'scrollPosition':scroll_position,
    				 'positionY':'top',
    				'positionX':'left',
    				'delay':10000,
    				"animationIn" : 'shake',
    				"animationIn_duration": 'slow',
    				"animationOut" : 'drop',
    				"animationOut_duration" : 'slow',
    			 }); })(jQuery);*/
            /* if(response['cartCount'] == 0){
             	window.location.href = "/cart";
             }*/
     	}</script>
    <script type="text/javascript">var checkPath = window.location.pathname;
  console.log(checkPath.includes('category'));
if(checkPath.includes('category') == false && sessionStorage.getItem('cartDropDown') == 'true' && sessionStorage.getItem('itemBooked') == 'true'){
  $('.login-UL li.cart .cartDiv').slideDown("500ms");
  sessionStorage.removeItem('itemBooked');
  sessionStorage.removeItem('cartDropDown');
}</script>




    <div id="ui-datepicker-div" class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all"></div>
</body>
</html>